<template>
  <Layout class="env" :class="{ linkKey }" :leftButtonName="$t('e-봉투 메뉴')" :rightButtonName="$t('참여자 정보')">
    <template v-if="env && !env.pwdExist">
      <template>
        <template slot="previous">
          <a class="btn btn-icon btn-active-secondary rounded-pill" @click="goBackToList(listParams.mode, listParams.dirId);">
            <i class="bi bi-chevron-left fs-2hx"></i>
          </a>
        </template>
        <template slot="toolbar">
          <template v-if="['view', 'sign'].includes(mode) && ['IPAD', 'WEB'].includes(device)">            
            <a class="btn btn-sm btn-light-primary" @click="showEnv()" :class="{'d-none': !env.signFileUrl}">
              <i class="bi bi-printer"></i>{{ $t('인쇄') }}
            </a>
            <b-dropdown id="dropdown-1" variant="light-primary" size="sm" :class="{'d-none': !env.signFileUrl}">
              <template #button-content>
                <i class="bi bi-download"></i>{{ $t('e-봉투 다운로드') }}
              </template>
              <b-dropdown-item @click="downloadEnv(`${env.signFileUrl}`)">
                {{ $t('e-봉투') }}
              </b-dropdown-item>
              <b-dropdown-item @click="downloadEnvAudit()">
                {{ $t('감사추적인증서') }}
              </b-dropdown-item>
            </b-dropdown>
            <a class="btn btn-sm btn-light-primary" @click.stop="action({ action: '이력' })" v-b-toggle.envAuditDrawer>
              <i class="bi bi-clock-history"></i>{{ $t('이력') }}
            </a>
          </template>
          <a v-if="device == 'WEB'" class="btn btn-sm btn-secondary" @click="goBackToList(listParams.mode, listParams.dirId);" v-text="$t('목록으로')" />
        </template>
        <template slot="content">
          <template v-if="mode == '발송조회'">
            <b-tabs>
              <b-tab :title="$t('기본정보')" class="card p-6">
                <div class="card-header" style="padding:0 7px">
                  <div class="card-title fw-bold">
                    <span v-html="env.envNm"></span>
                    <span class="text-muted fs-8 ms-3" v-html="env.tmplNm"></span>
                  </div>
                </div>
                <div class="p-4">
                  <ItemView :items="
                    [
                      {
                        'Product': env.prodNm,
                        '미확인 시 알림': `${this.$t('$ 일 경과', [env.unconfNotiDay || ''])}`,
                        TAG: { slot: 'TAG' },
                      },
                      {
                        'e-봉투 유효기간': env.signValidDay + $t('일'),
                        '서명 권한 위임': ({ Y: $t('가능'), N: $t('불가능') })[env.signMandateYn],
                      },
                    ]">
                    <template slot="TAG"><b-badge v-for="(tag, i) in (env.tag || '').split(',')" :key="i" v-text="tag" /></template>
                  </ItemView>
                </div>
                <div class="p-4">
                  <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
                    <b-icon icon="file-earmark-pdf" scale="1.3" variant="primary" class="me-3" />{{ $t('첨부문서') }}
                  </h4>
                  <b-row class="attached-doc-list">
                    <div @click="showDoc(item)" v-for="(item, i) in env.envDocList" :key="i">
                      <img :src="$url(item.thumbUrl)"> {{ item.docNm }}
                    </div>
                  </b-row>
                </div>
                <div class="p-4">
                  <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
                    <b-icon icon="person" scale="1.3" variant="primary" class="me-3" />{{ $t('참여자 역할') }}
                    <b-form-group v-if="env.sendType == 'BULK'" style="float:right;margin-top:-17px;width:110px"
                      label-cols="7" :label="$t('대량발송')">
                      <b-form-checkbox style="margin-right:25px" switch v-model="xlsMode" />
                    </b-form-group>
                  </h4>
                  <div v-if="xlsMode" class="xlsx">
                    <TableView :list="xlsxData.length ? this.xlsxData : []" class="xlsx-tb p-0" :minHeight="200"
                      hide-pagenation default-empty-msg="No Data">
                      <thead slot="thead" style="background-color:#f5f5f5">
                        <tr>
                          <th rowspan="2">No</th>
                          <th :key="i" v-for="( { roleNm }, i ) in env.envRoleList" v-text="roleNm" colspan="3" />
                          <th :key="i + 99" v-text="$t('제목')" rowspan="2" />
                          <th :key="i + 100" v-for="( key, i ) in xlsxKeys" v-text="key" rowspan="2" />
                        </tr>
                        <tr>
                          <template v-for="i in env.envRoleList.length">
                            <th :key="i" v-text="$t('성명')" />
                            <th :key="i + 100" v-text="$t('이메일')" />
                            <th :key="i + 200" v-text="$t('인증번호')" />
                          </template>
                        </tr>
                      </thead>
                    </TableView>
                  </div>
                  <div v-else class="role-list">
                    <b-col v-for="(item, i) in env.envRoleList" :key="i">
                      <b-col style="flex-grow:1">
                        <div class="color" :class="'ctrl-' + i" />
                        <div>
                          <label v-text="$t('역할')" />
                          <b-form-input readonly v-model="item.roleNm" />
                        </div>
                        <div>
                          <label v-text="$t('성명')" />
                          <b-form-input readonly :value="item.partiNm" />
                        </div>
                        <div>
                          <label v-text="$t('이메일')" />
                          <b-form-input class="min-w-250px" readonly :value="item.partiEmail" />
                        </div>
                        <div>
                          <label v-text="$t('작성완료방법')" />
                          <b-form-input readonly
                            :value="($code('TMPL_CONF_TYPE').find(t => t.value == item.confType) || {}).text" />
                        </div>
                        <div v-if="item.openType != 'LOGIN'">
                          <label v-text="$t('인증코드')" />
                          <b-form-input readonly v-model="item.authCode" />
                        </div>
                      </b-col>
                      <a @click="role = item; $nextTick(() => $bvModal.show('참여자 상세설정'))" style="white-space:nowrap;float:right" class="btn btn-sm btn-light-primary">상세설정</a>
                    </b-col>
                  </div>
                </div>
              </b-tab>
              <b-tab :title="$t('문서정보')" style="position:relative">
                <b-embed :class="{ full: signerFull }" class="embed" style="border-radius:0.65rem;border-top-left-radius:0" :src="`/signer/editor/${env.tmplId}${signerEditDisable}`" />
                <div class="editor-header-left gap-3" :class="{ 'fullscreen': signerFull }">
                  <a v-if="signerFull == true" class="icon" @click="signerFull = false"><i class="bi bi-fullscreen-exit fs-3 text-white"></i></a>
                  <a v-else class="icon" @click="signerFull = true"><i class="bi bi-fullscreen fs-3 text-white"></i></a>
                </div>
              </b-tab>
            </b-tabs>
          </template>
          <template v-else-if="mode == '추가' || mode == '수정'">
            <div v-if="signerStep" style="position:relative">
              <b-embed :class="{ full: signerFull }" class="card embed" :src="`/signer/editor/${env.tmplId}${signerEditDisable}`" />
            </div>
            <div v-show="!signerStep" class="card p-6">
              <div class="card-header" style="padding:0 11px">
                <div class="card-title fw-bold">
                  {{ env.tmplNm + (env.prodNm ? ` (${env.prodNm})` : '') }}
                  <span class="text-muted fs-8 ms-3" v-text="env.description" />
                </div>
                <div class="text-right">
                  <a class="btn btn-light-primary" @click="action({ action: '상세설정' })" v-text="$t('상세설정')" />
                </div>
              </div>
              <b-form-group class="p-4" :label="$t('e-봉투명')" label-class="required" label-cols="2">
                <b-form-input maxlength="100" v-model="env.envNm" />
              </b-form-group>
              <div class="p-4 mt-5">
                <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
                  <b-icon icon="file-earmark-pdf" scale="1.3" variant="primary" class="me-3" />{{ $t('첨부문서') }}
                </h4>
                <b-row class="attached-doc-list">
                  <div @click=" showDoc(item)" v-for="( item, i ) in env.envDocList" :key="i">
                    <img :src="$url(item.thumbUrl)"> {{ item.docNm }}
                  </div>
                </b-row>
              </div> 
              <div class="p-4">
                <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
                  <b-icon icon="person" scale="1.3" variant="primary" class="me-3" />{{ $t('참여자 역할') }}
                  <b-form-group style="float:right;margin-top:-17px;width:110px" label-cols="7" :label="$t('대량발송')">
                    <b-form-checkbox style="margin-right:25px" switch v-model="xlsMode" />
                  </b-form-group>
                </h4>
                <div v-if="xlsMode" class="xlsx">
                  <div class="mb-2">
                    <b-button class="me-5" @click="downloadXlsForm" variant="primary" v-text="$t('업로드용 템플릿 다운로드')" />
                    <b-button @click=" $bvModal.show('템플릿 업로드')" variant="primary" v-text="$t('템플릿 업로드')" />
                  </div>
                  <TableView :list="xlsxData.length ? this.xlsxData : []" class="xlsx-tb p-0" :minHeight="200" hide-pagenation
                    default-empty-msg="템플릿을 업로드 하세요">
                    <thead slot="thead" style="background-color:#f5f5f5">
                      <tr>
                        <th rowspan="2">No</th>
                        <th :key="i" v-for="(  { roleNm }, i  ) in  env.envRoleList " v-text="roleNm" colspan="3" />
                        <th :key="i + 99" v-text="$t('제목')" rowspan="2" />
                        <th :key="i + 100" v-for="( key, i ) in  xlsxKeys" v-text="key" rowspan="2" />
                      </tr>
                      <tr>
                        <template v-for=" i  in  env.envRoleList.length ">
                          <th :key="i" v-text="$t('성명')" />
                          <th :key="i + 100" v-text="$t('이메일')" />
                          <th :key="i + 200" v-text="$t('인증번호')" />
                        </template>
                      </tr>
                    </thead>
                  </TableView>
                </div>
                <div v-else class="role-list">
                  <b-col v-for="(  item, i  ) in  env.envRoleList " :key="i">
                    <b-col style="flex-grow:1">
                      <div class="color" :class="'ctrl-' + i" />
                      <div>
                        <label>{{$t('역할')}}<span class="text-danger ms-1">*</span></label>
                        <b-form-input disabled readonly v-model="item.roleNm" />
                      </div>
                      <template v-if="item.openType != 'LINK'">
                        <div>
                          <label>{{$t('성명')}}<span class="text-danger ms-1">*</span></label>
                          <div class="icon-btn icon-btn-left icon-btn-right">
                            <b-form-input maxlength="100" :value="item.partiNm || item.grpNm" :readonly="true" @click="openPartiSelTree(i + 1)"></b-form-input>
                            <a class="icon-left icon btn btn-sm btn-icon btn-circle btn-icon-dark btn-active-light-primary" :title="$t('조직도 선택')" @click="openPartiSelTree(i + 1)">
                              <i class="bi bi-person-lines-fill fs-3"></i>
                            </a>
                            <a class="icon-right icon btn btn-sm btn-icon btn-circle btn-icon-dark btn-active-light-danger" :title="$t('제거')" @click="removeParti(i + 1, item)">
                              <i class="bi bi-x fs-3"></i>
                            </a>
                          </div>
                        </div>
                        <div>
                          <label>{{$t('이메일')}}<span class="text-danger ms-1">*</span></label>
                          <b-form-input class="min-w-250px" maxlength="100" :value="item.partiEmail" :readonly="true" @click="openPartiSelTree(i + 1)"></b-form-input>
                        </div>
                      </template>
                      <template v-else>
                        <div>
                          <label>{{$t('성명')}}<span class="text-danger ms-1">*</span></label>
                          <div class="icon-btn icon-btn-right">
                            <b-form-input maxlength="100" :value="item.partiNm || item.grpNm"
                              @change="partiNm => Object.assign(item, { partiNm, userId: undefined, memberId: undefined, grpId: undefined, grpNm: undefined })" />
                            <a class="icon-right icon btn btn-sm btn-icon btn-circle btn-icon-dark btn-active-light-danger" :title="$t('제거')" @click="removeParti(i + 1, item)">
                              <i class="bi bi-x fs-3"></i>
                            </a>
                          </div>
                        </div>
                        <div>
                          <label>{{$t('이메일')}}<span class="text-danger ms-1">*</span></label>
                          <b-form-input class="min-w-250px" maxlength="100" :value="item.partiEmail"
                            @change="partiEmail => Object.assign(item, { partiEmail, userId: undefined, memberId: undefined, grpId: undefined, grpNm: undefined })" />
                        </div>
                      </template>
                      <div>
                        <label>{{$t('인증코드')}}<span v-if="item.openType == 'AUTH_CODE'" class="text-danger ms-1">*</span></label>
                        <b-form-input :disabled="item.openType == 'LOGIN'" v-model="env.envRoleList[i].authCode" />
                      </div>
                      <div>
                        <label v-text="$t('작성완료방법')" />
                        <b-form-input disabled readonly
                          :value="($code('TMPL_CONF_TYPE').find(t => t.value == item.confType) || {}).text" />
                      </div>
                      <div v-if="env.envRoleList[i].grpId" class="send-grp-all">
                        <label v-text="$t('그룹 전체 전송')" />
                        <b-form-checkbox switch @change="e => sendGrpAll(e, i)"
                          :checked="env.envRoleList[i].sendGrpAll" />
                      </div>
                    </b-col>
                    <a @click=" role = item; $nextTick(() => $bvModal.show('참여자 상세설정'))"
                      style="white-space:nowrap;float:right" class="btn btn-sm btn-light-primary">상세설정</a>
                  </b-col>
                </div>
              </div>
            </div>
          </template>
          <div class="env_sidebar_tab col align-items-start" v-else-if="mode == 'view' || mode == 'sign'">
            <div style="flex-grow:1;position:relative">
              <b-embed :class="{ full: signerFull || linkKey }" class="card embed" :src="`/signer/${env.tmplId}`" @load="bindSignerEvents()" />
              <div class="editor-header-left gap-3" :class="{ 'fullscreen': signerFull || linkKey }">
                <a v-if="signerFull || linkKey" class="icon" @click="signerFull = false"><i class="bi bi-fullscreen-exit fs-3 text-white"></i></a>
                <a v-else class="icon" @click="signerFull = true"><i class="bi bi-fullscreen fs-3 text-white"></i></a>
                <div v-show="editorValidResults.length > 0">
                  <b-dropdown ref="editorValid" left variant="link" toggle-class="p-0" menu-class="editor_valid bg-light-danger" no-caret>
                    <template #button-content>
                      <div class="position-relative">
                        <a class="icon btn btn-sm btn-icon btn-circle btn-icon-danger btn-active-light-danger"><i class="bi bi-bell-fill fs-3"></i></a>
                        <span class="position-absolute top-25 start-100 translate-middle badge badge-sm badge-circle badge-light-danger fs-9" v-text="editorValidResults.length"></span>
                      </div>
                    </template>
                    <b-dropdown-form>
                      <div class="d-flex justify-content-between align-items-center">
                        <h2 class="m-0">{{ $t('유효성 검사') }}</h2>
                        <div class="btn btn-xs btn-icon btn-color-gray-800 btn-active-color-primary close">
                          <i class="bi bi-x fs-1" @click.stop="$refs.editorValid.hide(true)"></i>
                        </div>
                      </div>
                      <div class="editor_valid_results">
                        <ul>
                          <li v-for="result of editorValidResults" class="link-all" @click="clickEditorValidResult(result)">
                            <span>{{ result.message }}</span>
                            <i class="bi bi-eye ms-3"></i>
                          </li>
                        </ul>
                      </div>
                    </b-dropdown-form>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <b-modal v-if="env.signFileUrl" modal-class="full" id="SHOW_ENV" :title="env.envNm" hide-footer centered>
              <b-embed :src="$url(env.signFileUrl)" allowfullscreen />
            </b-modal>
          </div>
          <div class="d-flex mt-3">
            <div class="flex-grow-1 text-muted">
              <template v-if="['view', 'sign'].includes(mode) && ['IPAD', 'WEB'].includes(device)">
                <div v-text="`${env.title || env.envNm || ''}`"></div>
                <div style="user-select:all" v-text="env.envId"></div>
                <div v-text="`${env.modUserNm} (${env.modDt.f('datetime-local')})${env.statusCd == 'COMPLETE' ? `, TSA ${$t('서명')}: ${(env.tsaDt || '').f('datetime-local')}` : ''}`"></div>
              </template>
            </div>
            <div class="env-btns">
              <template v-if="['추가', '수정'].includes(mode)">
                <template v-if="signerStep">
                  <a class="btn btn-secondary ms-3" @click="signerStepBack" v-text="$t('이전단계')" />
                  <a class="btn btn-warning ms-3" @click="save({ statusCd: 'TEMP' })" v-text="$t('임시저장')" />
                  <a v-if="isFirstParti()" @click="save({ statusCd: 'PROC' })" class="btn btn-success ms-3" v-text="$t('작성')" />
                  <a v-else class="btn btn-success ms-3" @click="save({ statusCd: 'PROC' })" v-text="$t('발송')" />
                </template>
                <template v-else>
                  <a class="btn btn-warning ms-3" @click="save({ statusCd: 'TEMP' })" v-text="$t('임시저장')" />
                  <a class="btn btn-primary ms-3" @click="save({ nextStep: true, statusCd: 'TEMP' })" v-text="$t('다음단계')" />
                </template>
              </template>
              <template v-else-if="['발송조회'].includes(mode)">
                <!-- 발송조회일 경우 버튼 없음 -->
              </template>
              <template v-else>
                <template v-if="!linkKey">
                  <a v-if="env.confable && ['IPAD', 'WEB'].includes(device)" class="btn btn-light-primary ms-3" @click="signerScope.print()" v-text="$t('미리보기')" />
                  <a v-if="env.trashable" class="btn btn-danger ms-3" @click="action({ action: '휴지통 이동' })" v-text="$t('휴지통')" />
                  <a v-if="env.deletable" class="btn btn-danger ms-3" @click="action({ action: '영구삭제' })" v-text="$t('영구삭제')" />
                  <a v-if="env.cancelable" class="btn btn-danger ms-3" @click="action({ action: '반려' })" v-text="$t('반려')" />
                  <a v-if="env.confable" class="btn btn-warning ms-3" @click="action({ action: '임시저장' })" v-text="$t('임시저장')" />
                  <a v-if="env.confable" class="btn btn-success ms-3" @click="action({ action: '작성완료' })" v-text="$t('작성완료')" />
                </template>
                <template v-else-if="linkKey && env.linkConfable">
                  <a v-if="env.confable && ['IPAD', 'WEB'].includes(device)" class="btn btn-light-primary ms-3" @click="signerScope.print()" v-text="$t('미리보기')" />
                  <a v-if="env.confable" class="btn btn-warning ms-3" @click="action({ action: '임시저장' })" v-text="$t('임시저장')" />
                  <a v-if="env.confable" class="btn btn-success ms-3" @click="action({ action: '작성완료' })" v-text="$t('작성완료')" />
                </template>
              </template>
            </div>
            <div class="env-left-btns">
              <template v-if="['sign'].includes(mode)">
                <template v-if="linkKey && !env.linkConfable">
                  <a class="btn btn-primary" @click="showEnv()" :class="{'d-none': !env.signFileUrl}"><i class="bi bi-printer"></i>{{ $t('인쇄') }}</a>
                </template>
              </template>
            </div>
          </div>
        </template>

        <div v-if="mode == 'view' || mode == 'sign'" slot="right" class="w-325px">
          <b-tabs slot="content" lazy class="ms-4">
            <b-tab id="env_parti" :title="$t('참여자')" class="card p-2 embed_tab">
              <div class="p-4 w-100 h-100 overflow-auto">
                <EnvPartiStat :env="this.env" :partiList="this.env.partiList" :mode="`col`" />
              </div>
            </b-tab>
            <b-tab v-if="['VIEW_WRITE', 'VIEW'].includes(env.myMsgUseType)" id="env_chat" class="card p-2 embed_tab">
              <template v-slot:title>
                <div class="position-relative ps-2">
                  <span v-text="$t('메시지')"></span>
                  <span class="text-muted fs-9 ms-1" v-text="envChatCnt"></span>
                  <span class="position-absolute top-0 start-0 translate-middle badge badge-sm badge-circle badge-light-danger fs-9" v-text="newEnvChatCnt"></span>
                </div>
              </template>
              <ChatView :recipientList="this.envRecipientList" :chatList="this.envChatList" 
                @insertChat="insertEnvChat" @confirmChat="confirmEnvChat" @deleteChat="deleteEnvChat"
                :writable="env.myTurn && ['VIEW_WRITE'].includes(env.myMsgUseType)"
                ></ChatView>
            </b-tab>
            <b-tab id="env_file" class="card p-2 embed_tab">
              <template v-slot:title>
                <div>
                  <span v-text="$t('첨부파일')"></span>
                  <span class="text-muted fs-9 ms-1" v-text="envFileCnt"></span>
                </div>
              </template>
              <FileView :fileList="this.envFileList" @insertFile="insertEnvFile" @deleteFile="deleteEnvFile" @download="downloadEnvFile"></FileView>
            </b-tab>
          </b-tabs>
        </div>

        <b-modal id="참여자추가" dialog-class="min-w-1024px" body-class="p-5 pt-3" :title="$t('참여자 추가')" hide-footer>
          <div class="d-flex flex-column">
            <div class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-end">
                <div class="d-flex align-items-center position-relative">
                  <b-icon icon="search" />
                  <input type="text" v-model="partiParams.searchKeyword" class="form-control form-control-solid form-control ps-11 pe-12 w-500px border-def" maxlength="100"
                    :placeholder="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                    :title="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                    @keydown="onTyping = true" 
                    @keyup.enter="searchPartiMemberList">
                  <a v-if="partiParams.searchKeyword" @click="removeSearchPartiMember"
                    class="icon btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary position-absolute end-0 me-1">
                    <i class="bi bi-x-circle fs-3"></i>
                  </a>
                </div>
                <a class="btn btn-secondary ms-1" :class="{'d-none': !partiSearchMode}" @click="removeSearchPartiMember">
                  <i class="bi bi-arrow-left-short"></i>{{ $t('조직도') }}
                </a>
              </div>
              <b-button v-if="!unmaskKey && (allPartiMemberList.length || partiMemberList.length)" class="btn-sm" @click="reqUnmask()" variant="warning">
                {{ $t('마스킹 해제') }}
              </b-button>
            </div>
            <div style="height: 64vh;" class="row">
              <div class="h-100 d-flex" :class="{'d-none': partiSearchMode}">
                <div class="h-100" style="width: 38%;">
                  <TreeView2 size="lg" :treeData="partiSelTree" @clicked="choicePartiGrp" height="100%" :customAction="partiSelTreeActions"
                    :filterHolder="$t('조직명, 그룹명')" showOuterBorder closeAll></TreeView2>
                </div>
                <div class="h-100 ms-4" style="width: 62%;">
                  <div class="ps-2" style="height: 30px;">
                    <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
                  </div>
                  <div style="height: calc(100% - 30px)">
                    <TableView ref="partiMemberTable" class="table-break-all" :list="partiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                      min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                      :columns="[
                        { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                        { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                        { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                      ]">
                    </TableView>
                  </div>
                </div>
              </div>
              <div class="h-100" style="width: 100%;" :class="{'d-none': !partiSearchMode}">
                <div class="ps-2" style="height: 30px;">
                  <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
                </div>
                <div style="height: calc(100% - 30px)">
                  <TableView ref="allPartiMemberTable" class="table-break-all" :list="allPartiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                    min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                    :columns="[
                      { key: 'custAbbr', label: 'Cust Abbr.', style: { textAlign: 'center' } },
                      { key: 'custName', label: '조직명', style: { textAlign: 'center' } },
                      { key: 'custFullName', label: '조직영문명', style: { textAlign: 'center' } },
                      { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                      { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                    ]">
                  </TableView>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal id="selCertiType" size="sm" centered no-close-on-backdrop hide-footer :title="this.$t('인증방법 선택')">
          <div class="d-flex justify-content-center flex-column" style="margin-top: -10px;">
            <b-button @click="selCertiTypeRes('kftc')" variant="light" block style="margin: 5px 0;">
              <img src="/img/kftc.png" style="height:1.4em;margin-right:0.7em">금융인증서
            </b-button>
            <b-button @click="selCertiTypeRes('pblc_cwui')" variant="light" block style="margin: 5px 0;">
              <img src="/img/pblc_cwui.png" style="height:1.4em;margin-right:0.7em">공동인증서
            </b-button>
          </div>
        </b-modal>

        <b-modal id="반려" :title="$t('반려')" content-class="w-450px" scrollable centered :ok-title="$t('반려')" ok-variant="danger" @ok="cancelEnv()">
          <div id="envCancelForm">
            <div v-for="(parti, index) in envCancelTargetList" :key="index" class="form-check form-check-sm form-check-custom form-check-solid mb-6">
              <input type="radio" class="form-check-input me-2" name="cancelParti" :id="`cancelParti_${parti.partiNo}`" :value="parti.partiNo" 
                :checked="index + 1 == envCancelTargetList.length" />
              <label :for="`cancelParti_${parti.partiNo}`">                
                <span class="parti_text"><b class="me-2">{{parti.roleNm}}</b>{{parti.partiNm}}{{parti.partiEmail ? ` (${parti.partiEmail})` : ''}}</span>
              </label>
            </div>
            <div class="mt-4">
              <textarea name="message" style="width:100%; height: 80px;" :placeholder="$t('메시지')"></textarea>
            </div>
          </div>
        </b-modal>

      </template>
      <ModalForm id="상세설정" :ok-title="!mode ? '확인' :'e-봉투에 반영'" :ok-only="!mode" form-only :spec="
        [          
          { label: 'Product', readonly:['상세설정'], key: 'prodId', default: '', options: $code('PRODUCT') },
          { label: 'e-봉투 유효기간', key: 'signValidDay', default: 90, type: 'number', append: $t('일') },
          { label: '미확인 시 알림', readonly:['상세설정'], key: 'unconfNotiDay', default: 2, type: 'number', append: $t('일 경과') },
          { label: '서명 권한 위임', readonly:['상세설정'], key: 'signMandateYn', default: 'N', type: 'radio', options: $code('POSS') },
          { label: 'TAG', key: 'tag', type: 'tag' },
        ]
        " @action="({ form }) => Object.assign(env, form)" :data="env" />
      <ModalForm id="참여자 상세설정" @action="({ form }) => role = Object.assign(role, form)" ok-only form-only :spec="
        [
          { label: '수행업무', key: 'taskId', options: $code('TASK') },
          { label: 'e-봉투 개봉방법', key: 'openType', options: $code('TMPL_OPEN') },
          { label: 'e-봉투 조회권한', key: 'viewType', options: $code('ENV_VIEW_TYPE') },
          { label: '메시지 사용', key: 'msgUseType', default: 'VIEW_WRITE', options: $code('TMPL_MSG_USE_TYPE') },
          { label: '회람 완료 시', key: 'atEndRcvCd', default: 'NOTI_ENVFILE_ATTACH', options: $code('TMPL_AT_END_RCV') },
          { label: '위임자 추가', key: 'partiAddPossYn', default: 'N', type: 'radio', options: $code('POSS') },
          { label: '다음 참여자 추가', key: 'checkerAddPossYn', default: 'N', type: 'radio', options: $code('POSS') },
          { label: '메시지', key: 'guide', type: 'textarea' },
        ]
        " :data="role" />
      <b-modal v-if="doc.docFileUrl" modal-class="full" id="파일보기" :title="doc.docNm" hide-footer centered>
        <b-embed :src="$url(doc.docFileUrl)" allowfullscreen />
      </b-modal>
    </template>
    
    <template v-if="!env || env.pwdExist" slot="sub_title">{{ this.subTitle }}</template>

    <div v-if="!env || env.pwdExist" slot="left" class="w-225px">
      <b-button class="mb-2" @click=" getSrcTmpl()" variant="primary" block v-text="$t('e-봉투 만들기')" />
      <MenuView class="mb-3" ref="menuView" @clicked="onMenu" :menus="envMenus" />
      <TreeView class="mb-3" ref="treeView" title="내 폴더" labelKey="dirNm" :tree="dirTree" @context="contextTree" :hasContextMenu="true"
        @clicked="({ item }) => onTree(item, $t('내 폴더'))" />
    </div>

    <TableView v-show="!env || env.pwdExist" :keep-page="keepPage" slot="content"
      :list="list" :server-total="serverTotal" @nextList="getList()"
      :columns="device == 'WEB' ? envColumns : envColumnsMobile" 
      :filters="device == 'WEB' ? filters : []"
      :filterHides="device == 'WEB' ? filterHides : []"
      @action="action"
      :actions="['휴지통 이동', '영구삭제', '전송', '다운로드', '발송조회']"
      :action-filter="(item, action) =>
        (action == '휴지통 이동' && item.trashable) || 
        (action == '영구삭제' && item.deletable) || 
        (action == '전송' && item.statusCd == 'SAVE') || 
        (action == '다운로드' && item.statusCd != 'TEMP') || 
        (action == '발송조회' && item.writerFlag && item.statusCd != 'TEMP')"
      :check-actions="
        listParams.mode == 'trash' ? [
          {text: '영구삭제', variant: 'danger'}, 
          {text: '폴더이동', variant: 'secondary'}
        ] : 
        listParams.mode == 'send' || listParams.mode == 'receive' || listParams.mode == 'temp' || listParams.mode == 'dir' ? [
          (auths.includes('MAIN_ENV_CONF_RESEND') ? {text: 'Reminder', variant: 'primary'} : null), 
          {text: '휴지통 이동', variant: 'danger'}, 
          {text: '폴더이동', variant: 'secondary'}, 
          {text: '다운로드', variant: 'light-primary'}
        ] : 
        []
      ">
        <div class="d-flex">
          <div class="d-flex align-items-center position-relative me-3">
            <b-icon icon="search" />
            <input maxlength="100" id="listSearchKeyword" @change="listParams.searchKeyword = $event.target.value" class="form-control form-control-solid w-200px ps-11"
              :placeholder="$t('e-봉투ID, e-봉투명, 참여자, 발신자, 태그')" :title="$t('e-봉투ID, e-봉투명, 참여자, 발신자, 태그')" v-b-tooltip.hover />
          </div>
          <b-button variant="light-primary" v-b-modal.상세>
            <b-icon icon="filter" /> {{ $t('상세') }}
          </b-button>
        </div>
        <template v-slot:keyword>
          <div v-if="dataSearch.val || dataSearch.from || dataSearch.to" class="d-flex fs-6 fw-bolder">
            <span v-text="$t('상세 검색')"></span>
            <span class="ms-1 me-2">:</span>
            <span v-if="dataSearch.type == 'text'" class="text-primary" v-text="dataSearch.val"></span>
            <span v-else-if="dataSearch.type == 'date'" class="text-primary d-flex">
              <span v-text="dataSearch.from"></span><span class="mx-1">~</span><span v-text="dataSearch.to"></span>
            </span>
            <span v-else-if="dataSearch.type == 'currency'" class="text-primary d-flex">
              <span v-text="dataSearch.from.f('num')"></span><span class="mx-1">~</span><span v-text="dataSearch.to.f('num')"></span>
            </span>
          </div>
        </template>
    </TableView>
    <ModalForm id="상세" @cancel="resetSearch" @show="setDataSearchTypeChange" @action="goDataSearch"
      modal-class="border-none" size="w-450" title="상세 검색" ok-title="검색" cancel-title="초기화" :data="dataSearch" form-only
      :spec="dataSearchSpec" close-on-backdrop />
    <b-modal id="partiList" :title="$t('진행상태')" centered hide-footer size="w-600">
      <TableView ref="partiTable" :filter="partiFilters" :columns="partiColumns" min-width="auto" @action="partiListAction"
        style="margin:-40px -1.5rem -1rem" v-if="sel" :list="sel.envEachList" min-height="auto">
      </TableView>
    </b-modal>

    <b-modal id="modalEnvFileList" :title="$t('첨부파일') + ` (${this.envFileList.length})`" centered hide-footer size="w-400" body-class="px-2 pt-2 pb-4">
      <FileView :fileList="this.envFileList" :pageable="true" 
        @insertFile="insertEnvFile" @deleteFile="deleteEnvFile" @download="downloadEnvFile" :customStyle="{maxHeight: '360px'}"></FileView>
    </b-modal>

    <b-modal id="fileList" modal-class="compact" centered hide-footer size="w-600">
      <TableView :title="$t('첨부파일')" :check-actions="[{text: '다운로드', variant: 'light-primary'}]" @action="fileAction" min-width="auto"
        :actions="['다운로드']"
        :icon-actions="{'bi-download': '다운로드', 'bi-trash-fill': '삭제'}"
        :action-filter="(item, action) => (action == '다운로드') || (action == '삭제' && item.deletable)"
        style="margin:-1.5rem -1.5rem -1rem"
        :columns="[
          // { label: '종류', key: 'attachTypeNm' }, 
          { label: '파일명', renderer: r => `${r.filename}<span class='text-muted fs-8 ms-2'>${r.size.f('file_size')}</span>` }, 
          { label: '생성자', renderer: r => `${r.regUserNm}` },
          { label: '생성일', renderer: r => `${r.regDt.f('datetime-local')}`, class: 'text-muted' },
        ]"
        :list="fileList" min-height="auto">
        <b-button v-b-modal.파일추가 variant="primary" class="me-2">
          <i class="bi bi-plus-circle"></i>{{ $t('파일추가') }}
        </b-button>
        <b-button @click=" $bvModal.hide('fileList')">
          {{ $t('닫기') }}
        </b-button>
      </TableView>
    </b-modal>
    <ModalForm id="파일추가" @action="fileAction" title="파일추가" ok-title="저장" cancel-title="취소" form-only
      :spec="[{ key: 'files', label: '첨부파일', type: 'file' }]" close-on-backdrop />
    <b-modal id="일괄 폴더이동" size="sm" :title="$t('폴더이동')" @ok="moveFolder" :ok-title="$t('폴더이동')" :cancel-title="$t('취소')">
      <TreeView @clicked="({ item }) => selFolder = item" radio labelKey="dirNm" :tree="dirTree" :hasRowEvent="false" />
    </b-modal>
    <b-modal id="템플릿선택" :title="$t('템플릿 선택')" hide-footer scrollable>
      <TreeView ref="srcTmpl" @clicked="selSrcTmpl" :tree="srcTmplTree" size="lg" :expandDepth="1" :hasFilter="true" :filterHolder="$t('템플릿')"
        labelKey="tmplNm" hide-sel-bg :customAction="srcTmplActions" />
    </b-modal>
    <b-modal centered id="템플릿 업로드" :title="$t('템플릿 업로드')" hide-footer>
      <div class="dropzone">
        <div>
          <div v-text="$t('템플릿 csv')" /><small>(Click or Drag & Drop)</small>
        </div>
        <input type="file" accept=".csv" @change="loadXlsx" />
      </div>
    </b-modal>
    <ModalForm id="dirModal" size="sm" modal-class="border-none" label-cols="0" :data="dirModal.data"
      @action="({ form }) => contextTreeAction(dirModal.act, dirModal.item, form)" :title="dirModal.title" form-only
      :spec="[{ placeholder: '폴더명', key: 'dirNm' }]">
      <div class="mb-3 gray-txt" v-html="`${this.$t('대상폴더명')}: ${dirModal.item && dirModal.item.dirNm}`" />
    </ModalForm>
    <b-modal id="순서변경" centered scrollable hide-footer @ok=" setTree(true)" size="sm" :title="$t('폴더 순서변경')" ok-only
      :ok-title="$t('확인')">
      {{ $t('드래그하여 순서조정') }}
      <draggable class="dir-sibling" v-model="dirSibling" v-bind="dragOptions" @change="contextTreeAction('순서변경')">
        <div :key="i" v-for="(dir, i) in dirSibling">
          {{ dir.dirNm }}<b-icon icon="arrows-move" />
        </div>
      </draggable>
    </b-modal>
    <canvas style="display:none" />
    <div id="canvasDiv" style="display:none" />

    <template v-if="envAuditList && env">
      <b-sidebar id="envAuditDrawer" :title="$t('이력')" bg-variant="white" right backdrop shadow @shown="selectEnvAudit">
        <div :key="idx" v-for="(envAudit, idx) in this.envAuditList">
          <div class="px-4 mb-4 border-bottom border-gray-200">
            <div class="fw-semibold">
              <div class="d-flex justify-between">
                <div href="#" class="fs-7 fw-bold text-gray-900">
                  <b :class="['fs-8', 'me-3', 'badge', 'badge-light-' + envAudit.actTypeClass]">{{ envAuditList.length - idx }}. {{ envAudit.actTypeNm }}</b>
                </div>
                <div class="fs-8 text-muted text-right">
                  {{ envAudit.actUserNm }}<span v-if="envAudit.actEmail != null" class="ms-1">({{ envAudit.actEmail }})</span>
                  <div>{{ envAudit.actDt.f('datetime-local') }}</div>
                </div>
              </div>
              <div class="d-flex align-items-center p-2">
                <div style="flex: 1;" :class="['fs-7']">
                  {{ envAudit.actCont }}
                  <div class="mt-1" v-if="envAudit.actReason !== null">{{ $t('반려사유') }}: {{ envAudit.actReason }}</div>
                </div>
                <div style="flex: 0;" v-if="envAudit.fileUrl && envAudit.actType == 'ENV_ACT_RETURN'">
                  <a class="link fs-4" @click.stop="downloadEnv(envAudit.fileUrl)"><b-icon icon="paperclip" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-sidebar>
    </template>
  </Layout>
</template>

<script>
import draggable from 'vuedraggable';
import Layout from "@/components/layout/Layout.vue";
import TreeView from "@/components/TreeView.vue";
import TreeView2 from "@/components/TreeView2.vue";
import TableView from "@/components/TableView.vue";
import MenuView from "@/components/MenuView.vue";
import ModalForm from "@/components/ModalForm.vue";
import ItemView from "@/components/ItemView.vue";
import EnvPartiStat from "@/components/env/EnvPartiStat.vue";
import ChatView from "@/components/cmm/ChatView.vue";
import FileView from "@/components/cmm/FileView.vue";
import { inihub } from '@/config';
import Vue from 'vue'
import { TooltipPlugin } from 'bootstrap-vue'
Vue.use(TooltipPlugin);

const taskIdCheck = 'CHECK';
let selCertiTypeResFunc;

export default {
  components: { draggable, Layout, TreeView, TreeView2, TableView, MenuView, ModalForm, ItemView, EnvPartiStat, ChatView, FileView },
  computed: {
    user() { return this.$store.state.user },
    auths() { return this.user.auths || [] },
    dragOptions() { return { animation: 250, ghostClass: "ghost" }; },
    device() { return this.$getDevice(); },
    defListParams() { return { mode: 'receive', dirId: '', statusCd: null, prodId: null , searchKeyword: '', type: null, val: null, from: null, to: null }; },
    defDataSearch() { return { type: 'text', val: '', from: '', to: '' } },
  },
  data: () => ({
    envMenus: [
      { icon: 'inboxes', label: '수신함', key: 'receive' }, 
      { icon: 'box-arrow-up-right', label: '발신함', key: 'send' }, 
      { icon: 'journals', label: '임시 보관함', key: 'temp' }, 
      { color: 'danger', icon: 'trash', label: '휴지통', key: 'trash' }
    ],
    subTitle: '', envDirList: [],
    keepPage: false, sel: {}, selEach: {}, env: null, envCancelTargetList: [], list: [], envSeq: 0, linkKey: undefined, docPwds: null, mode: '',
    dirTree: [], dirModal: {}, dirSibling: [], selFolder: null,
    tmplKeyword: '', srcTmplTree: [], doc: {}, role: {}, saving: false,
    signerScope: {}, editorTestMode: false, signerStep: false, signerFull: false, signerEditDisable: '?disable=true',
    fileList: [], taskIdCheck, envAuditList: [],
    xlsMode: false, xlsx: null, xlsxData: [], xlsxKeys: [],
    editorValidResults: [],
    envColumns: [
      {
        label: '상태', key: 'statusNm', style: { textAlign: 'center' },
        renderer: (r, s) => {
          let statusEl = `<b class="badge badge-light-${r.statusClass}">${r.statusNm}</b>`;
          if(r.returned || r.expired) {
            statusEl += `
              <div class="mt-1">
                ${r.returned ? `<b class="badge badge-sm badge-light-danger">${s.$t('반려')}</b>` : ''}
                ${r.expired ? `<b class="badge badge-sm badge-light-${r.expiredClass}">${r.expiredNm}</b>` : ''}
              </div>
            `;
          }
          return statusEl;
        },
      },
      { 
        label: 'e-봉투명', key: 'envNm', style: { fontWeight: 'bold', minWidth: '160px', maxWidth: '240px' },
        renderer: (r) => {          
          return (`
            ${r.envNm}${r.pwdExist ? '<i class="bi bi-lock-fill text-primary ms-2"></i>' : ''}
            ${r.tag ? `<div class="text-primary fs-8 fw-normal">${r.tag.f('tag_exp')}</div>` : ''}
          `);
        }
      },
      {
        label: '진행', 
        component: r => {
          if(r && r.envEachList[0] && r.envEachList[0].partiList && r.envEachList[0].partiList.length > 0) {
            return Vue.extend(EnvPartiStat).extend({ 
              data: () => { return { envData: r, partiDatas: r.envEachList[0].partiList }; } 
            });
          } else {
            return () => {};
          }
        },
      },
      { label: '템플릿', key: 'tmplNm' },
      { label: 'Product', key: 'prodNm', style: { textAlign: 'center' } },
      { label: '업무상태', renderer: r => `${[(r.responseDt || '').f('datetime-local'), r.responseMsg].filter(a => a).join('<br>')}`, style: { textAlign: 'center' } },
      { label: '발신자\n발송일', renderer: r => `${r.modUserNm} (${r.modUserId})<br>${r.modDt.f('datetime-local')}`, style: { textAlign: 'center' } },
      { 
        label: '파일',         
        renderer: (r, s) => {
          if(r.envEachList.length == 1) {
            return `
              <a class="btn btn-icon btn-circle btn-icon-dark btn-active-light-primary position-relative" data-u="envAttach" title="${s.$t('파일')}">
                <i class="bi bi-paperclip fs-3" data-u="envAttach"></i>
                <span class="fs-9 position-absolute top-25 start-100 translate-middle badge badge-circle badge-light-warning">
                  ${r.envEachList[0].extFileCnt + r.envEachList[0].intFileCnt + r.envEachList[0].chatFileCnt}
                </span>
              </a>
            `;
          } else {
            return ``;
          }
        }
      }
    ],
    envColumnsMobile: [
      {
        label: '상태', key: 'statusNm', style: { textAlign: 'center' },
        renderer: (env) => {
          const envEachList = env.envEachList;
          const envEach = env.envEachList[0];
          let html = `
            <div class="env-item d-flex w-100">
              <div class="flex-grow-1 text-left">
                <div>
                  <b class="text-${env.statusClass}">${env.statusNm}</b>
                  <b v-if="env.returned" class="ms-3 text-danger"></b>
                  <b v-if="env.expired" class="ms-3 text-${env.expiredClass}">${env.expiredNm}</b>
                </div>
                <div class="mt-1">
                  <span class="fs-5 fw-bold">${env.envNm}</span>
                </div>
                <div>
                  <span class="text-gray-400 fs-8">
                    <span>${env.modUserNm} (${env.modUserId})</span>
                    <span class="ms-2">${env.modDt.f('datetime-local')}</span>
                  </span>
                </div>
                ${
                  env.tag ?
                  `
                    <div>
                      <span v-if="env.tag" class="text-primary fw-normal fs-8">${env.tag.f('tag_exp')}</span>
                    </div>
                  ` : ``
                }
              </div>
              ${
                envEachList.length == 1 ? 
                `
                  <div class="flex-grow-0 d-flex align-items-center">
                    <b class="badge badge-sm badge-light-info fs-8">
                      ${envEach.partiList.filter(item => item.confStatusCd == 'CONF').length}
                      <span class="mx-1">/</span>
                      ${envEach.partiList.length}
                    </b>
                  </div>
                ` : ``
              }
            </div>
          `;
          return html;
        },
      },
    ],
    dataSearchSpec: [],
    dataSearch: { type: 'text', val: '', from: '', to: '' },
    listParams: { mode: 'receive', dirId: '', statusCd: null, prodId: null , searchKeyword: '', type: null, val: null, from: null, to: null },
    serverTotal: 0, 
    filters: [{ key: 'statusCd', label: '상태', cd: 'ENV_STATUS' }, { key: 'prodId', label: 'Product', cd: 'PRODUCT' }], 
    filterHides: [],
    partiFilters: { statusNm: [] },
    partiColumns: [
      { label: '상태', key: 'statusNm', style: { textAlign: 'center' }, renderer: (r) => { return `<b class="badge badge-light-${r.statusClass}">${r.statusNm}</b>`; }, },
      { label: 'e-봉투명', renderer: (r) => `${r.title || r.envNm || ''}` },
      {
        label: '진행', 
        component: r => {
          return Vue.extend(EnvPartiStat).extend({ 
            data: () => { return { envData: r, partiDatas: r.partiList }; } 
          });
        },
      },
      { 
        label: '파일', 
        style: { width: '80px' },
        renderer: (r, s) => {
          return `
            <a class="btn btn-icon btn-circle btn-icon-dark btn-active-light-primary position-relative" data-u="envAttach" title="${s.$t('파일')}">
              <i class="bi bi-paperclip fs-3" data-u="envAttach"></i>
              <span class="fs-9 position-absolute top-25 start-100 translate-middle badge badge-circle badge-light-warning">
                ${r.extFileCnt + r.intFileCnt + r.chatFileCnt}
              </span>
            </a>
          `;
        }
      }
    ], 
    envRecipientList: [], envChatList: [], envChatCnt: 0, newEnvChatCnt: 0, envFileList: [], envFileCnt: 0,
    partiSelTree: '', unmaskKey: '', onTyping: false, partiSearchMode: false,
    partiMemberList: [], allPartiMemberList: [], partiParams: { selType: '', selKey: '', searchKeyword: '' },  
  }),
  created() {
    if (this.user.linkKey) {
      this.linkKey = this.user.linkKey;
      this.env = this.user.env;
      this.env.pwdExist = false;
      this.mode = 'sign';
    }
    else {
      this.$setProdTask();
      this.setTree();
      this.changeMode({mode: 'receive'});
      // 필터 코드가 설정된 후 실행될 수 있도록 처리

      this.dataSearchSpec = [
        {
          requiredIcon: true, label: '검색 유형', key: 'type', default: 'text', 
          options: [
            { text: this.$t('검색어 포함'), value: 'text' }, 
            { text: this.$t('날짜 범위지정'), value: 'date' }, 
            { text: this.$t('금액 범위지정'), value: 'currency' }
          ]
        },
        { requiredIcon: true, label: '검색어', hide: ['상세'], key: 'text' },
        { requiredIcon: true, label: '날짜 범위', hide: ['상세'], default: [], type: 'date-between', key: 'date' },
        { requiredIcon: true, label: '금액 범위', hide: ['상세'], default: [], type: 'number-between', key: 'currency' },
      ];
    }
    // 사이너 에디터를 위한 인터페이스
    window.ktdp = signerScope => new Promise(async (resolve, reject) => {
      const { signFileUrl, tmplId, envNo, envRoleList, partiList, myPartiNo, myUi, envSeq, envDocList: docs } = this.env || this.sel;
      this.signerScope = signerScope;
      let data;
      if (envNo) {
        if (this.signerStep || !envSeq) {
          data = (await this.$api('main/env/selectEnvEditor', { envNo })).data;
        } else {
          if(!this.linkKey) {
            data = (await this.$api('main/env/selectEnvSigner', { envNo, partiNo: myPartiNo, envSeq })).data;
          } else { // 링크 서명
            data = (await this.$api('nonauth/main/env/selectEnvSigner', { envNo, partiNo: myPartiNo, envSeq, linkKey: this.linkKey })).data;
          }
        }
      }
      else data = (await this.$api('main/tmpl/selectTmplEditor', { tmplId })).data;
      if (!data.ctrls && data.jsonCtrls) data.ctrls = JSON.parse(data.jsonCtrls);
      // if (!data) data = (await this.$api('main/tmpl/selectTmplEditor', { tmplId })).data;
      try {
        if (!data || !data.ctrls) throw 'error no ctrls';
        else if (!docs || docs.length < 1) throw 'error no DocList';
        const title = this.$t('문서 변환 중...');
        await this.$store.commit('progress', { title, progress: 1 });
        await this.$loadScript('/libs/pdf.min.3.0.279.js');
        await this.$loadScript('/libs/pdf2png.js');
        data.docs = [];
        // data = await this.$api(this.$url(data.jsonFileUrl));
        // todo: 기 저장된 pdf 인 경우 서버것을 가져와서 문서 한개짜리로 세팅필요
        if (signFileUrl) {
          const pages = await window.pdf2png(this.$url(signFileUrl), window.canvasDiv, (page, total) => this.$store.commit('progress', { title, progress: Math.round(page * 100 / total) }));
          let i = 0;
          if (docs[0].pageCount) {
            for (const doc of docs) {
              i += doc.pageCount;
              data.docs.push({ name: doc.docNm, pages: pages.slice(i - doc.pageCount, i) });
            }
          } else {
            data.docs.push({ name: docs.length > 1 ? this.env.envNm : docs[0].docNm, pages });
          }
        } else {
          for (const doc of docs) {
            data.docs.push({
              name: doc.docNm, pages: await window.pdf2png(
                this.$url(doc.docFileUrl), window.canvasDiv, (page, total) => this.$store.commit('progress', { title, progress: Math.round(page * 100 / total) })
              )
            });
          }
        }
      } catch (e) {
        this.$store.commit('progress', { progress: 100 });
        await this.$alert(`<pre>${this.$t('문서를 가져오는데 실패했습니다.<br>($)', [e + ''])}</pre>`, { size: 'lg' });
        reject(e);
        if (this.linkKey) this.exit();
        else this.$go(-1);
      }
      this.$store.commit('progress', { progress: 100 });
      if (data.datas) {
        for (const key in data.datas) {
          const inputs = data.ctrls.filter(c => c.key == key);
          if (inputs.length == 1 && !inputs[0].value) inputs[0].value = data.datas[key];
          else if (inputs.length > 1) {
            if (inputs[0].type == 'radio' && !inputs.find(i => i.value))
              (inputs.find(i => i.optionVal == data.datas[key]) || {}).value = true;
            else if (inputs[0].type == 'check') {
              const vals = Array.isArray(data.datas[key]) ? data.datas[key] : [data.datas[key]];
              inputs.forEach(i => { if (vals.includes(i.optionVal)) i.value = true });
            }
          }
        }
      }

      // 현재 서명자
      const myParti = (partiList || envRoleList).find(r => r.partiNo == myPartiNo);
      if (this.signerStep || this.mode == '발송조회') {
        data.users = (partiList || envRoleList).map((r, i) => Object.assign(r, { i: i + '' })).map(r => {
          return { name: r.roleNm, i: r.i, h: r.confType == 'ENV_REF' || r.taskId == taskIdCheck };
        });
      } else {
        data.ctrls = data.ctrls.filter(c => c.ui == myUi || (c.type == 'file' && c.value) || (c.type == 'memo' && c.content));
        data.role = (myParti || { partiNo: -1 });
      }
      resolve(data);
      const confType = (this.env.confable && (myParti || {}).confType) + '';
      if (confType.indexOf('_CERTI') > 0) {
        // this.env.confable = false;
        await this.$loadScript('/libs/inihub.js');
        // inihub.type = await this.selCertiType();
        // try {
        //   console.log('IHUB_C.init', { type: inihub.type, baseUrl: inihub.baseUrl||location.origin, clientId: inihub.clientId });
        //   inihub.init = await window.IHUB_C.init({ type: inihub.type, baseUrl: inihub.baseUrl||location.origin, clientId: inihub.clientId });
        //   this.env.confable = true;
        // } catch(e) {
        //   if (!inihub.init) this.$alert(this.$t('전자서명을 준비할 수 없습니다.'));
        // }
      }
    });
  },
  watch: {
    xlsMode: 'setXlsExtras',
    listParams: { deep: true, handler() { this.getList(true); } },
    envChatList: { deep: true, handler() { this.refreshEnvChatCnt(); } },
    envFileList: { deep: true, handler() { this.refreshEnvFileCnt(); } },
    '$route.query': {
      handler(query) {
        if(query.tmplId) {
          this.selEnv('추가', {tmplId: query.tmplId});
        } else if(query.id) {
          this.selEnv((query.action || 'view'), { envNo: query.id, envSeq: query.seq || '' });
        } else {
          this.initEnv();
          if(this.listParams != null) {
            this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId}, false);
          }
        }
      },
      immediate: true 
    }
  },
  methods: {
    selCertiTypeRes(sel) {
      this.$bvModal.hide('selCertiType');
      selCertiTypeResFunc(sel);
    },
    selCertiType() {
      this.$bvModal.show('selCertiType');
      return new Promise(res => selCertiTypeResFunc = res);
    },
    exit() {
      if (history.length > 1) history.back();
      else window.close();
    },
    sendGrpAll(e, i) {
      const { target: checked } = window.event;
      for (const el of this.$el.querySelectorAll('.send-grp-all :checked')) el.checked = el == checked;
      const { envRoleList: list } = this.env;
      (list.find(r => r.sendGrpAll) || {}).sendGrpAll = false;
      list[i].sendGrpAll = e;
    },
    async showDoc(item) {
      this.doc = item;
      await this.$delay(100);
      this.$bvModal.show('파일보기');
    },
    async signerStepBack() {
      if (this.signerEditDisable || (await this.$alert(this.$t('편집중인 내용은 저장되지 않습니다.<br>계속 하시겠습니까?'), { confirm: true })))
        this.signerStep = false;
    },
    async partiListAction({ item, event }) {
      if (event && event.target.dataset.u == 'envAttach') {
        this.openFileList(item);
        return;
      }
      
      this.$bvModal.hide('partiList');
      this.$go(`/env?id=${this.sel.envNo}&seq=${item.envSeq}`);
    },
    onMenu({ key: menu }) {
      this.changeMode({mode: menu});
    },
    async setDataSearchTypeChange(formScope) {
      formScope.form.type = this.dataSearch.type;
      formScope.form.text = this.dataSearch.val;
      formScope.form.date = formScope.form.type == 'date' ? [this.dataSearch.from, this.dataSearch.to] : [];
      formScope.form.currency = formScope.form.type == 'currency' ? [this.dataSearch.from, this.dataSearch.to] : [];
      await this.$nextTick();
      let elType = document.querySelectorAll('.modal-body .custom-select');
      if(elType && elType[0]) {
        elType[0].onchange = () => this.dataSearchSpec.slice(1, 4).forEach(s => s.hide = elType[0].value == s.key ? [] : ['상세']);
        this.dataSearchSpec.slice(1, 4).forEach(s => s.hide = elType[0].value == s.key ? [] : ['상세']);
      }
    },
    async goDataSearch({ form, evt }) {
      Object.assign(this.dataSearch, { type: form.type, from: '', to: '', val: '' });
      if (form.type == 'text') {
        if(!form.text) {
          this.$alert(this.$t('검색어를 입력하세요.'));
          return evt.preventDefault();
        }
        this.dataSearch.val = form.text;
      } else if (form.type == 'date') {
        let from = form[form.type][0];
        let to = form[form.type][1];
        if(!from || !to) {
          this.$alert(this.$t('시작범위와 종료범위를 입력하세요.'));
          return evt.preventDefault();
        } else if (from > to) {
          this.$alert(this.$t('시작범위가 종료범위보다 큽니다.'));
          return evt.preventDefault();
        }
        Object.assign(this.dataSearch, {from, to});
      } else if (form.type == 'currency') {
        let from = form[form.type][0];
        let to = form[form.type][1];
        if(!from || !to) {
          this.$alert(this.$t('시작범위와 종료범위를 입력하세요.'));
          return evt.preventDefault();
        } else if (parseFloat(from.replaceAll(',', '')) > parseFloat(to.replaceAll(',', ''))) {
          this.$alert(this.$t('시작범위가 종료범위보다 큽니다.'));
          return evt.preventDefault();
        }
        Object.assign(this.dataSearch, {from, to});
      }
      Object.assign(this.listParams, { ...this.dataSearch });
    },
    resetSearch() {
      Object.assign(this.listParams, this.defListParams);
      Object.assign(this.dataSearch, this.defDataSearch);
      document.querySelector('#listSearchKeyword').value = '';
      setTimeout(() => document.activeElement.blur(), 500);      
    },
    async setXlsExtras(v) {
      if (!v) {
        return this.xlsxKeys = [];
      }
      const { data: { jsonCtrls } } = await this.$api('main/tmpl/selectTmplEditor', { tmplId: this.env.tmplId });
      const ctrls = JSON.parse(jsonCtrls);
      let uniqueCtrls = ctrls.reduce((acc, current) => {
        if (!acc.find(item => item.key === current.key)) {
          acc.push(current);
        }
        return acc;
      }, []);
      uniqueCtrls = uniqueCtrls.filter(item => item.key);

      this.xlsxKeys = uniqueCtrls.map(c => c.key);
      this.xlsxKeys.filter((c, i) => this.xlsxKeys.indexOf(c) == i);
      let bulkPartiList = this.env.bulkPartiListJson ? JSON.parse(this.env.bulkPartiListJson) : null;
      if (bulkPartiList && this.xlsxData.length == 0) {
        for (const bulkParti of bulkPartiList) {
          let row = {}, i = 0;
          row[i++] = this.xlsxData.length + 1
          bulkParti.partiList.forEach(p => { row[i++] = p.partiNm; row[i++] = p.partiEmail; row[i++] = p.authCode; });
          row[i++] = bulkParti.title;
          this.xlsxKeys.forEach(k => row[i++] = bulkParti[k]);
          this.xlsxData.push(row);
        }
      }
    },
    async setTree(resetCache) {
      let dirIds = [];
      this.dirTree = [];
      const list = await this.$tree('main/env/selectEnvDirList', {}, resetCache);
      for (const dir of list) {
        dirIds.push(dir.dirId);
        dir.key = dir.dirId;
        this.envDirList.push({...dir});
        if (dir.pDirId > 0) list.find(d => d.dirId == dir.pDirId).children.push(Object.assign(dir, { children: [] }));
        else this.dirTree.push(Object.assign(dir, { children: [] }));
      }

      if(this.listParams.mode == 'dir' && this.listParams.dirId) {
        if(dirIds.length == 0 || !dirIds.some(dirId => dirId == this.listParams.dirId)) {
          this.changeMode({mode: 'receive'});
        } else {
          this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId});
        }
      }
    },
    onTree(dir, dirNm) {
      if (dir) {
        if (!dir.dirId) return;
        this.changeMode({mode: 'dir', dirId: dir.dirId});
      }
      else {
        this.dirModal = {
          data: {}, title: '하위폴더 추가', act: 'insert', item: { dirNm, dirId: 0 }
        };
        this.$bvModal.show('dirModal');
      }
    },
    async contextTreeAction(act, item, form) {
      if (act == '순서변경') {
        let newSort;
        this.dirSibling.some((dir, i) => {
          if (dir.sort == i + 1) return;
          else if (dir.sort == i + 2) {//뒤쪽에서 찾아야함
            let j = i + 1;
            while (this.dirSibling[j].sort != i + 1) j++;
            item = this.dirSibling[j];
            newSort = j + 1;
          }
          else {// 자신이 옮겨짐
            item = dir;
            newSort = i + 1;
          }
          return true;
        })
        const res = await this.$api('main/env/changeEnvDirSort', { dirId: item.dirId, newSort });
        if (res.success) {
          this.dirSibling.forEach((dir, i) => dir.sort = i + 1);
          this.setTree(true);
          document.querySelectorAll('.toast').forEach((toast) => { toast.remove(); });
          this.$toast(res.msg, { variant: 'success', toaster: 'b-toaster-bottom-right' });
        } else {
          this.$alert(res.msg);
        }
        return;
      }
      if (!form.dirNm) return this.$alert(this.$t('폴더명을 확인하세요'));
      const res = await this.$api(`main/env/${act}EnvDir`, { dirId: item.dirId, pDirId: item.dirId, dirNm: form.dirNm });
      if (res.success) this.setTree(true);
      else this.$alert(res.msg);
    },
    contextTree({ evt, item, sibling }) {
      this.$store.commit('contextmenu', {
        evt, menu: {
          하위폴더추가: () => {
            this.dirModal = { data: {}, title: '하위폴더 추가', act: 'insert', item };
            this.$bvModal.show('dirModal');
          }, 이름변경: () => {
            this.dirModal = { data: { dirNm: item.dirNm }, title: '폴더 이름변경', act: 'update', item };
            this.$bvModal.show('dirModal');
          }, 순서변경: () => {
            if (sibling.length == 1) return this.$alert(this.$t('형제 폴더가 없습니다.'));
            this.dirSibling = sibling;
            this.$bvModal.show('순서변경');
          }, 삭제: async () => {
            if (!(await this.$alert(this.$t('$ 폴더를 삭제하시겠습니까?', [item.dirNm]), { confirm: true }))) return;
            const res = await this.$api('main/env/deleteEnvDir', { dirId: item.dirId });
            if (res.success) this.setTree(true);
            else this.$alert(res.msg);
          }
        }
      });
    },
    async save({ nextStep, statusCd }) {
      if (this.saving) return this.$toast(this.$t('진행중입니다.'), { title: '' });
      const { envNo, tmplId, envNm, prodId, unconfNotiDay, signValidDay, signMandateYn, tag, envRoleList } = this.env;
      const data = { envNo, statusCd: statusCd || this.env.statusCd, tmplId, envNm, prodId, unconfNotiDay, signValidDay, signMandateYn, tag, envRoleList, envDocList: [] };
      const regEmail = /^[\w-.*]+@([\w-]+\.)+[\w-]{2,4}$/;
      if (this.xlsMode) {
        if (this.xlsxData.length == 0) return this.$alert(this.$t('참여자를 추가하세요.'));
        const roleLen = this.env.envRoleList.length;
        const titleIdx = roleLen * 3 + 1;
        const dataStart = titleIdx + 1;
        const envEachList = [];
        for (const tr of document.querySelectorAll('.xlsx-tb tbody tr')) {
          const vals = tr.querySelectorAll('td'), partiList = [], extras = {};

          // 참여자
          for (let i = 0; i < roleLen; i++) {
            partiList.push({ partiNm: vals[i * 3 + 1].innerText.trim(), partiEmail: vals[i * 3 + 2].innerText.trim(), authCode: vals[i * 3 + 3].innerText.trim() });
          }

          // 타이틀
          if(vals[titleIdx].innerText.trim()) {
            extras.envTitle = vals[titleIdx].innerText.trim();
          }

          // 데이터
          if(this.xlsxKeys) {
            this.xlsxKeys.forEach((key, idx) => {
              if(vals[dataStart + idx].innerText.trim()) {
                extras[key] = vals[dataStart + idx].innerText.trim();
              }
            });
          }
          envEachList.push({ partiList, ...extras });
        }
        data.bulkPartiListJson = JSON.stringify(envEachList);
      } else if (data.envRoleList.find(r => r.openType == 'AUTH_CODE' && !r.authCode)) {
        return this.$alert(this.$t('인증번호 항목을 입력하세요'));
      } else if (data.envRoleList.find(r => !r.grpId && this.$isEmpty(r.partiEmail))) {
        return this.$alert( this.$t('이메일을 입력하세요.') );
      } else if (data.envRoleList.find(r => !r.grpId && !regEmail.test(r.partiEmail))) {
        return this.$alert( this.$t('$ 형식을 확인하세요.', [this.$t('이메일')]) );
      }
      data.envDocList = this.env.envDocList.map(({ docSeq, docId, ver }) => ({ docSeq, docId, ver }));
      if (!data.envNm || !data.envNm.trim()) return this.$alert(this.$t('e-봉투명 항목을 입력하세요'));
      data.envRoleList.forEach(r => { if (r.openType == 'LOGIN') delete r.authCode });
      if (this.editorTestMode && !(await this.$alert(`<pre>${JSON.stringify(data, null, '  ')}</pre>`, { title: '임시로 전송될 json 확인', confirm: true, size: 'lg' }))) return;
      this.saving = true;
      try {
        // 첫사용자가 본인이어서 바로 발송하는 케이스
        const directSend = !this.signerScope.tmpl;
        data.action = nextStep ? 'NEXT_STEP' : 'TEMP';
        const res = await this.$api('main/env/' + (data.envNo ? 'updateEnv' : 'insertEnv') + (this.xlsMode ? 'Bulk' : ''), data);
        if(!res.success) {
          if(this.xlsMode) {
            const resultHtml = `<ul>${res.msg.split('\n').filter(item => item !== '').map(item => `<li>${item}</li>`).join("")}</ul>`;
            this.$alert(resultHtml, {size: 'w-400', contentClass: 'mh-500px'});
            return;
          } else {
            this.$alert(res.msg);
          }
        } else if (res.success && res.data && res.data.envNo) {
          this.env.envNo = res.data.envNo;
        }

        if (res.success && nextStep && this.env.envNo) { // 기본정보 입력 단계
          this.signerStep = true;
        }

        // 임시저장일 경우
        if (statusCd == 'TEMP') {
          if(!nextStep) {
            await this.$alert(res.msg);
          }

          this.changeMode({mode: 'temp'});
          return;
        } else if (statusCd == 'PROC') {
          const formData = this.$json2formdata({});// docs: this.signerScope.tmpl.docs });
          formData.append('envNo', envNo);
          if (directSend) formData.append('jsonCtrls', (await this.$api('main/tmpl/selectTmplEditor', { tmplId: this.env.tmplId })).data.jsonCtrls);
          else formData.append('jsonCtrls', JSON.stringify(this.signerScope.tmpl.ctrls));
          try {
            await this.$api('main/env/insertEnvEditor', formData, { errors: { 500: '' } });
          } catch (e) { console.log('insertEnvEditor error', e) }

          if (statusCd && res.success) {
            if(this.isFirstParti()) { // 첫 참여자가 본인인 경우
              await this.$alert(this.$t('작성 화면으로 이동합니다.'));
              const envKey = { envNo: `${this.env.envNo}`, envSeq: 1 };
              this.initEnv();
              this.changeMode({mode: 'receive'});
              this.$nextTick(() => {
                this.$go(`/env?id=${envKey.envNo}&seq=${envKey.envSeq}`);
              });
              return;
            } else {
              await this.$alert(res.msg);
              this.initEnv();
              this.changeMode({mode: 'send'});
              return;
            }
          }
        }
      }
      catch (e) {
        this.saving = false;
        throw e;
      } finally {
        this.$store.commit('progress', { keep: 0 });
        this.saving = false;
      }
    },
    isFirstParti() {
      // 첫 참여자가 본인인 경우, 그룹전송이 아님 and (첫 참여자가 본인 or 본인 그룹)
      // 단건 전송일 경우만 바로작성 제공
      if(this.env) {
        const sendGrpAllLen = this.env.envRoleList.filter(r => r.sendGrpAll).length;
        const partiUserId = this.env.envRoleList[0].userId;
        const partiGrpId = this.env.envRoleList[0].grpId || '';
        const thisUser = this.$store.state.user;
        let firstParti = sendGrpAllLen == 0 && !this.xlsMode && (partiUserId == thisUser.userId || (partiGrpId != '' && partiGrpId == thisUser.grpId));
        return firstParti;
      } else {
        return false;
      }
    },
    async loadXlsx(e) {
      this.xlsxData = Object.values(await this.$loadXlsx(e.target.files[0], 'euc-kr'))[0];
      let tbody = Object.values(await this.$loadXlsx(e.target.files[0], 'euc-kr', 'html'))[0];
      document.querySelector('.xlsx-tb tbody').innerHTML = tbody.slice(tbody.indexOf('</tr>') + 5, tbody.lastIndexOf('</table>'));
      this.$bvModal.hide('템플릿 업로드');
    },
    async fileAction({ item, action, form }) {
      if (action == '파일추가') {
        form.append('envNo', this.envNo);
        form.append('envSeq', this.envSeq);
        form.append('attachType', 'EXTERNAL');
        const { success, msg } = await this.$api((this.linkKey ? 'nonauth/' : '') + 'main/env/insertEnvAttachFileList', form);
        if (success) {
          this.openFileList(item);
          this.$toast(msg, { variant: 'success', toaster: 'b-toaster-bottom-right' });
        } else {
          this.$alert(msg);
        }
      } else if (action == '삭제') {
        if (!(await this.$alert(this.$t(action + ' 하시겠습니까?'), { confirm: true }))) return;
        const { success, msg } = await this.$api('main/env/deleteEnvAttachFile', { fileId:item.fileId });
        if (success) {
          this.fileList.splice(this.fileList.indexOf(item), 1);
          this.$toast(msg, { variant: 'success', toaster: 'b-toaster-bottom-right' });
        } else {
          await this.$alert(msg, { title: item.filename });
        }
      }

      // 첨부파일 개수 리프레시
      if (action == '파일추가' || action == '삭제') {
        if(this.env) {
          this.selEnv('view', {envNo: this.env.envNo, envSeq: this.env.envSeq});
          this.refreshEnv([this.envNo]);
        }

      }
    },
    downloadXlsForm() {
      const colNms = ['No'];
      this.env.envRoleList.forEach(r => {
        colNms.push(r.roleNm + ' ' + this.$t('이름'), r.roleNm + ' ' + this.$t('이메일'), r.roleNm + ' ' + this.$t('인증코드'));
      });
      colNms.push(this.$t('제목'));
      colNms.push(...this.xlsxKeys);
      this.$saveAs(new Blob(['\ufeff"', colNms.join('","'), '"'], { type: 'text/csv;charset=utf-8' }), this.env.tmplNm + '.csv');
    },
    authError() {
      // this.$router.replace('/env');
      this.$go(-1);
    },
    async goBackToList(mode, dirId) {
      this.$router.push(`/env`).then(() => {
        this.initEnv();
        this.changeMode({mode, dirId}, false);
      });
    },
    async initEnv() {
      this.$bvToast.hide();
      this.docPwds = null;
      this.env = null;
      this.editorValidResults = [];
    },
    async selEnv(action, envKey) {
      this.$bvToast.hide();

      this.xlsxData = [];
      this.xlsMode = false;
      this.saving = false;
      this.signerStep = false;

      if (action == '추가') { // 추가
        try {
          let res = { code: -1 }, times = 0, tmpl = {};
          while (times++ < 5 && res.code != 1) {
            if (tmpl && tmpl.pwdExist) this.docPwds = await this.$matchDocPwd(tmpl.tmplDocList);
            res = await this.$api('main/tmpl/selectTmpl', { tmplId: envKey.tmplId, docPwds: this.docPwds });
            if (times == 1 && !this.docPwds && res.data && res.data.pwdExist) {
              res.code = -1;
              tmpl.pwdExist = true;
              tmpl.tmplDocList = res.data.tmplDocList;
            }
            else if (res.code != 1) await this.$alert(res.msg);
          }
          if (res.code == 1) {
            tmpl = Object.assign(res.data, { editable: undefined, deletable: undefined, trashable: undefined, confable: undefined, cancelable: undefined });
            // 템플릿 정보를 e-봉투에 셋팅
            tmpl.envNm = tmpl.tmplNm;
            tmpl.envDocList = tmpl.tmplDocList;
            tmpl.envRoleList = tmpl.tmplRoleList;
            this.env = tmpl;

            // 내 템플릿의 경우 에디터에서 속성창 안보이도록 처리
            if (this.env.pTmplId && this.env.pTmplId != '0')  this.signerEditDisable = '?disable=valueonly';
          }
        } catch (e) {
          console.log(e);
          return;
          // return this.authError();
        }
      } else { // 수정, 발송조회, view, sign
        let res = { code: -1 }, authCode;
        res = await this.$api('main/env/selectEnv', { envNo: envKey.envNo, envSeq: envKey.envSeq || '' });
        if (res.code == -1) {
          setTimeout(() => document.querySelector('#auth_code_input').focus(), 100);
          if (!(await this.$alert(`<input maxlength=100 id=auth_code_input type="password" class="form-control" placeholder="${this.$t('인증코드')}">`, { title: this.$t('인증코드'), confirm: true }))) return this.$router.replace('/env');
          authCode = window.auth_code_input.value;
          res = await this.$api('main/env/selectEnv', { envNo: envKey.envNo, envSeq: envKey.envSeq, authCode });
        }

        if (res.code != 1) {
          this.$alert(res.msg);
          return this.authError();
        }
        else {
          // e봉투 상세조회 시
          this.env = res.data;
          this.refreshEnvCancelTarget();
          this.refreshEnvChat();
          this.refreshEnvFile();
        }

        // 임시저장 상태일 경우 바로 `수정`모드로 이동
        if(this.env.statusCd == 'TEMP') {
          action = '수정';
        }

        // 대량발송일 경우
        if (this.env.sendType == 'BULK') {
          if (['발송조회', '수정'].includes(action)) {
            this.xlsMode = true;
          }
        }

        // 작성차례 참여자 접근 시
        if (this.env.myPartiNo != null && !this.env.chatId) {
          action = 'sign';
          const myParti = this.env.partiList.find(r => r.partiNo == this.env.myPartiNo);
          const h = this.$createElement;

          // 반려일 경우 반려 사유 표시
          if (myParti.returned) {
            const title = h('div', [
              h('strong', { class: ['fs-7'] }, `(${this.$t('반려')}) ${myParti.confStatusUserNm}`),
              h('span', { class: ['ms-2', 'text-muted', 'fs-9'] }, `${myParti.confStatusDt.f('datetime-local')}`)
            ]);
            this.showEnvMsg(title, myParti.confStatusReason, 'danger');
          }

          // 안내문구 표시
          if (myParti.guide) {
            const title = h('div', [
              h('strong', { class: ['fs-7'] }, `${this.$t('메시지')}`)
            ]);
            this.showEnvMsg(title, myParti.guide);
          }
        }
      }

      if(this.env) delete this.env.pwdExist;
      this.mode = action;
    },
    async selSrcTmpl({ item, evt, treeView }) {
      const { target: { dataset: { u } } } = evt || { target: {} };
      if(u == 'tmplFav') { // 즐겨찾기
        const res = await this.$api('main/tmpl/favoriteTmpl', { tmplId: item.tmplId });
        if(res.success) {
          this.$bvModal.hide('템플릿선택');
          document.querySelectorAll('.toast').forEach((toast) => { toast.remove(); });
          this.$toast(res.msg, { variant: res.data == 'Y' ? 'success' : 'danger', toaster: 'b-toaster-bottom-right' });
          return this.getSrcTmpl();
        } else {
          return this.$alert(res.msg);
        }
      } else { // e봉투 만들기
        if(item.children) {
          treeView.toggleItem(evt);
        } else {
          this.$bvModal.hide('템플릿선택');
          await this.selEnv('추가', {tmplId: item.tmplId});
        }
      }
    },
    srcTmplActions(item) {
      const fav = this.srcTmplTree[0].children.find(t => t.tmplId == item.tmplId);
      return item.children ? '' : `
        <a class="btn btn-xs btn-icon btn-circle btn-icon-dark btn-active-secondary me-2 ms-6" title="${this.$t('e-봉투 만들기')}" data-u="envCreate">
          <i class="bi bi-box-arrow-up-right fs-4 text-primary" data-u="envCreate"></i>
        </a>
        <a class="btn btn-xs btn-icon btn-circle btn-icon-dark btn-active-secondary" title="${this.$t('즐겨찾기')}" data-u="tmplFav">
          <i class="bi bi-star${fav ? '-fill' : ''} fs-4 text-${fav ? 'warning' : 'dark'}" data-u="tmplFav"></i>
        </a>
      `;
    },
    async getSrcTmpl() {
      this.srcTmplTree = [
        { class: 'fw-bolder', icon: false, tmplNm: this.$t('즐겨찾기'), children: [] }, 
        { class: 'fw-bolder', icon: false, tmplNm: this.$t('내 템플릿'), children: [] }, 
        { class: 'fw-bolder', icon: false, tmplNm: this.$t('공유 템플릿'), children: [] }, 
        { class: 'fw-bolder', icon: false, tmplNm: this.$t('조직 템플릿'), children: [] }
      ];
      const { data: { favTmplList, tmplDirList: list } } = await this.$api('main/env/selectSrcTmpl', {});

      /** 즐겨찾기 */
      let favChildren = [...favTmplList];
      for (const item of favChildren) {
        Object.assign(item, { type: 'terminal', icon: 'bi-file-earmark' });
      }
      this.srcTmplTree[0].children = favChildren;

      /** 템플릿 */
      const ownerTypeMap = { MY: 1, SHARE: 2, CUST: 3 };
      for (const dir of list) {
        let children = dir.tmplList;
        for (const item of children) {
          Object.assign(item, { icon: 'bi-file-earmark' });
        }
        if (dir.pDirId > 0) list.find(d => d.dirId == dir.pDirId).children.push(Object.assign(dir, { tmplNm: dir.dirNm, children }));
        else this.srcTmplTree[ownerTypeMap[dir.ownerType]].children.push(Object.assign(dir, { tmplNm: dir.dirNm, children }));
      }

      this.tmplKeyword = '';
      this.$bvModal.show('템플릿선택');
    },
    async moveFolder(evt) {
      if (!this.selFolder) {
        evt.preventDefault();
        return this.$alert(this.$t('폴더를 선택하세요.'));
      }
      const { dirId, ownerType } = this.selFolder, success = [], fail = [];
      const { list } = await this.$api('main/env/moveEnvToDir', { envNos: this.sel.map(e => e.envNo), dirId, ownerType });
      (list || []).map(({ result: r }, i) => { if (r) success.push(this.sel[i].envNm); else fail.push(this.sel[i].envNm) });
      if (success.length) {
        await this.$alert(this.$t('[$] 파일을 [$] 폴더로 이동했습니다.', [success.join(), this.selFolder.dirNm]) + (fail.length ? '<br>' + this.$t('실패한 항목: [$]', [fail.join()]) : ''));
        if(dirId) {
          await this.changeMode({mode: 'dir', dirId: dirId}, true);
        } else {
          await this.getList(true);
        }
      }
      else this.$alert(this.$t('실패했습니다.'));
    },
    async action({ action, item, form, event }) {
      if (item) this.sel = item;

      if (action == '발송조회') {
        return this.$go(`/env?id=${item.envNo}&action=발송조회`);
      }
      else if (action == 'view') { 
        if (event && event.target.dataset.u == 'envAttach') {
          this.openFileList(item);
          return;
        }

        if (this.sel.statusCd == 'TEMP') { // 임시저장일 경우 바로 '수정' 모드로 이동
          return this.$go(`/env?id=${this.sel.envNo}`);
        } else if (this.sel.envEachList.length > 1) { // e봉투 개별건이 2건 이상인 경우
          this.$bvModal.show('partiList');
          this.$nextTick(() => {
            this.partiFilters = { statusNm: [...new Set(this.sel.envEachList.map(r => r.statusNm || ''))] };
            this.$refs.partiTable.setFilter();
          });
        } else { // e봉투 개별건이 1건인 경우
          let envSeq = this.sel.envEachList[0].envSeq || '';
          return this.$go(`/env?id=${this.sel.envNo}&seq=${envSeq}`);
        }
      }
      else if (action == '작성완료' || action == '임시저장' || action == '반려' || action == '휴지통 이동' || action == '영구삭제' || action == '전송') {
        let { envNo, myPartiNo: partiNo, envSeq } = this.env || this.sel, res;

        if (action == '작성완료' || action == '임시저장') {
          const formData = this.$json2formdata({});

          if (action == '임시저장') {
            const newInputs = JSON.stringify(this.signerScope.inputs.filter(i => i.ui == this.signerScope.role.ui));
            const result = await window.ktdp_api('replaceEnvCtrls', { newInputs: newInputs, statusCd: 'TEMP' });
            await this.$alert(result.rstxt);
            return;
          }

          // 필수, 금액, 숫자 체크
          this.genEditorValidResult();
          
          if(this.editorValidResults.length > 0) {
            if(await this.$alert(this.$t('미입력 또는 잘못 입력된 항목이 있습니다.<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)'), { size: 'w-350' })) {
              this.toggleEnvAlerts(true);
            }
            return;
          }

          const myParti = this.env.partiList.find(r => r.partiNo == this.env.myPartiNo) || {};
          
          /* 확인자 추가 */
          let checkUser;
          if (myParti.checkerAddPossYn == 'Y' && myParti.nextPartiType2 == 'PARTI' && myParti.openType != 'LINK') { // 확인자 추가 가능 and 다음 참여자가 일반 참여자일 경우
            const { list: checkUsers } = await this.$api('main/env/selectEnvCheckerList', {});
            if (checkUsers.length > 0) {
              const alertContent = `
                <div class="ms-1 mb-3">${this.$t('다음 확인자를 선택하세요.')}</div>
                <select class="custom-select custom-select-lg" id="check_user">
                  <option value="">${this.$t('확인자 추가 없이 작성완료')}</option>
                  ${checkUsers.map((u, i) => `<option value="${i}">${u.userNm} (${u.userId}, ${u.email})</option>`)}
                </selct>
              `;
              if (!(await this.$alert(alertContent, { confirm: true, okTitle: this.$t('작성완료'), title: this.$t('확인자 추가'), size: 'w-400' }))) return;
              if (window.check_user.value) {
                checkUser = checkUsers[window.check_user.value];
                formData.append('checkerAddYn', 'Y');
                formData.append('userId', checkUser.userId);
                formData.append('partiNm', checkUser.userNm);
                formData.append('partiEmail', checkUser.email);
              }
            }
          }

          if (!(await this.$alert(this.$t(action + ' 하시겠습니까?'), { okTitle: this.$t('작성완료'), confirm: true, size: 'sm' }))) return;
          
          /* 인증서 서명 */
          if (myParti.confType.indexOf('_CERTI') > 0) {
            // (env.envRoleList.find(r=>r.partiNo==env.myPartiNo)||{}).confType; 2:공동(pblc_cwui), 3:금융(kftc)
            inihub.type = await this.selCertiType();
            const clientId = inihub.clientId[myParti.confType.indexOf('C_') == 0 ? 1 : 0];
            try {
              console.log('IHUB_C.init', { type: inihub.type, baseUrl: inihub.baseUrl || location.origin, clientId });
              inihub.init = await window.IHUB_C.init({ type: inihub.type, baseUrl: inihub.baseUrl || location.origin, clientId });
            } catch (e) {
              if (!inihub.init) return this.$alert(this.$t('전자서명을 준비할 수 없습니다.'));
            }
          }

          if (action == '작성완료') {
            await window.ktdp_api('drawSign', myParti.confType, { type: inihub.type });
            const newInputs = JSON.stringify(this.signerScope.inputs.filter(i => i.ui == this.signerScope.role.ui));
            await window.ktdp_api('replaceEnvCtrls', { newInputs: newInputs, statusCd: 'CONF' });

            // const formData = this.$json2formdata({ docs: await this.signerScope.saveDocs() });
            formData.append('envNo', envNo);
            formData.append('partiNo', partiNo);
            if (envSeq) formData.append('envSeq', envSeq);
            const datas = {}, inputs = this.signerScope.inputs.filter(i => i.value && i.key);
            inputs.forEach(i => {
              if (i.type == 'currency') return datas[i.key] = i.value.replace(/[^.\d]/g, '');
              else if (i.type != 'check') return datas[i.key] = i.optionVal || i.value;
              else if (!datas[i.key]) datas[i.key] = inputs.filter(i2 => i.key == i2.key && i2.value).map(i => i.optionVal || true);
            });
            formData.append('jsonDatas', JSON.stringify(datas));
            if (this.linkKey) formData.append('linkKey', this.linkKey);
            res = await this.$api((this.linkKey ? 'nonauth/' : '') + 'main/env/confEnv', formData);
          }
        }
        else if (action == '반려') {
          this.$bvModal.show('반려');
          return;
        }
        else if (!(await this.$alert(this.$t('[$] 하시겠습니까?', [action]), { confirm: true }))) return;
        else res = await this.$api('main/env/' + ({ '휴지통 이동': 'moveEnvTrash', 영구삭제: 'deleteEnv', 전송: 'procEnv' })[action], { envNo, partiNo, envSeq });

        await this.$alert(res.msg);
        if (res.success) {
          if (this.linkKey) {
            this.env = (await this.$api('nonauth/main/env/linkSigner', { linkKey: this.linkKey, authCode: this.$store.state.enteredAuthCode })).data;
            return this.$el.querySelector('iframe').contentDocument.location.reload();
          } else {
            if(this.env) {
              this.initEnv();
              this.$router.push(`/env`).then(() => {
                this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId}, true);
              });
            } else {
              this.initEnv();
              this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId}, true);
            }
            return;
          }          
        }
        return;
      }
      else if (action == '일괄 Reminder' || action == '일괄 휴지통 이동' || action == '일괄 영구삭제') {
        if (!(await this.$alert(this.$t('[$] 하시겠습니까?', [action]), { confirm: true }))) return;
        const success = [], fail = [], { list } = await this.$api('main/env/' + ({ Reminder: 'resendEnvConf', '휴지통 이동': 'moveEnvTrash', 영구삭제: 'deleteEnv' })[action.slice(3)], { envNos: item.map(i => i.envNo) });
        (list || []).map(({ result: r }, i) => { if (r) success.push(item[i].envNm); else fail.push(item[i].envNm) });
        if (success.length) {
          await this.$alert(this.$t('[$] 봉투를 $ 했습니다.', [success.join(), action.slice(3)]) + (fail.length ? '<br>' + this.$t('실패한 항목: [$]', [fail.join()]) : ''));
          if (action != '일괄 Reminder') this.getList(true);
        }
        else this.$alert(this.$t('실패했습니다.'));
        return;
      }
      else if (action == '다운로드' || action == '일괄 다운로드') {
        let envNosStr;
        if (action == '다운로드') {
          envNosStr = item.envNo;
        } else {
          let uniqTmplId = [...new Set(item.map(i => i.pTmplId == 0 ? i.tmplId : i.pTmplId))];
          if (uniqTmplId.length == 1) {
            envNosStr = item.map(i => i.envNo).join(',');
          } else {
            await this.$alert(`${this.$t('동일한 템플릿을 선택하세요.')}`);
            return;
          }
        }
        this.$downloadAuth(`/ktdp/v1/main/env/downloadEnv?mode=${this.listParams.mode}&envNosStr=${envNosStr}`, 'e-envelope datas.xlsx');
      }
      else if (action == '첨부파일') {
        this.openFileList(this.env);
        return;
      }
      this.selFolder = null;
      this.$bvModal.show(action);
    },
    async toggleEnvAlerts(open) {
      if(this.$refs.editorValid) {
        if(open) {
          setTimeout(() => { this.$refs.editorValid.show(true); }, 200);
        } else {
          this.$refs.editorValid.hide(true);
        }
      }
    },
    /** 작성완료 시, 유효성 검사 */
    genEditorValidResult(targetInput) {
      const transInputs = this.signerScope.getTransInputs();
      if(transInputs) {
        if(targetInput) {
          // 항목 지정된 경우, 해당 항목만 유효성 검사
          const input = transInputs.find(obj => obj.ctrlName == targetInput.ctrlName);
          this.editorValidResults.forEach((currResult, idx) => {
            if(currResult.ctrlName == input.ctrlName) {
              const result = this.checkEditorValidResult(input);
              if(result) {
                currResult = result;
              } else {
                this.editorValidResults.splice(idx, 1);
              }
            }
          });
        } else {
          // 전체 유효성 검사
          this.editorValidResults = [];
          transInputs.forEach(input => {
            const result = this.checkEditorValidResult(input);
            if(result) {
              this.editorValidResults.push(result);
            }
          });
        }
      }
    },
    /** 유효성 체크 */
    checkEditorValidResult(input) {
      const NUMBER_REGEX = /^(?!.*,,)(?!.*[.].*[.])([0-9]|[0-9][0-9,\.]*[0-9])$/;
      const CURRENCY_REGEX = /^\d{1,3}(,\d{3})*(\.\d{1,2})?$/;
      const DATE_REGEX = /^(?:\d{4}-\d{2}-\d{2}|\d{8})$/;
      let message = '';

      // 필수 체크
      if(input.required === true && this.$isEmpty(input.value)) {
        message = this.$t('필수 입력값이 누락되었습니다.');
      }

      // 형식, 길이 체크
      if(!this.$isEmpty(input.value)) {
        if(input.type == 'number' && !NUMBER_REGEX.test(input.value)) {
          message = this.$t('$ 형식을 확인하세요.', [this.$t('숫자')]) ;
        } else if(input.type == 'currency' && !CURRENCY_REGEX.test(input.value)) {
          message = `${this.$t('$ 형식을 확인하세요.', [this.$t('금액')])} ###,###,###`;
        } else if(input.type == 'date' && !DATE_REGEX.test(input.value)) {
          message = `${this.$t('$ 형식을 확인하세요.', [this.$t('날짜')])} ####-##-##`;
        } else if(input.type == 'text' && Number(input.maxlength || 0) != 0 && input.value.length > Number(input.maxlength)) {
          message = this.$t('입력값이 최대 길이를 초과했습니다. (최대: $)', [input.maxlength]);
        }
      }

      if(message) {
        if(this.$isNotEmpty(input.key)) {
          message += ` (${input.key})`;
        } else if(this.$isNotEmpty(input.label)) {
          message += ` (${input.label})`;
        } else if(this.$isNotEmpty(input.value)) {
          message += ` (${input.value})`;
        } else if(this.$isNotEmpty(input.type)) {
          message += ` (${input.type})`;
        }
        
        return { ctrlName: input.ctrlName, docIndex: input.di, tabIndex: input.tabIndex, message };
      } else {
        return null;
      }
    },
    clickEditorValidResult(result) {
      this.toggleEnvAlerts(false);
      this.signerScope.tabControl(result.docIndex, result.tabIndex);
    },
    async selectEnvAudit() {
      const result = (await this.$api('main/env/selectEnvAudit', { envNo: this.env.envNo, envSeq: this.env.envSeq })).data;
      this.envAuditList = result.envAuditList;
    },
    async cancelEnv() {
      const form = { envNo: this.env.envNo, envSeq: this.env.envSeq };
      const envCancelForm = document.getElementById('envCancelForm');
      form.partiNo = envCancelForm.querySelectorAll('[name=cancelParti]:checked')[0].value;
      form.confStatusReason = envCancelForm.querySelector('[name=message]').value;
      let res = await this.$api('main/env/cancelEnv', form);
      await this.$alert(res.msg);
      if(res.success) {
        this.initEnv();
        this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId});
        this.$go(`/env`);
        return;
      }
    },
    async changeMode(params, reset = true) {
      this.$nextTick(() => {
        let thisParams = { mode: params.mode || 'receive', dirId: params.dirId || ''};
        if(reset) {
          // reset일 경우, 검색 파라미터 초기화
          document.querySelector('#listSearchKeyword').value = '';
          Object.assign(this.dataSearch, this.defDataSearch);
          thisParams = Object.assign(this.defListParams, thisParams);
        } else {
          // reset이 아닐 경우, 검색 파라미터 유지
          thisParams = Object.assign(this.listParams, thisParams);
        }

        // 검색 파라미터 셋팅
        Object.assign(this.listParams, thisParams);

        // 메뉴뷰, 트리뷰 선택 처리
        if(thisParams.mode == 'dir') {
          if(this.$refs.treeView) {
            this.$refs.treeView.selectByKey(thisParams.dirId);
          }
        } else {
          if(this.$refs.menuView) {
            this.$refs.menuView.selectByKey(thisParams.mode);
          }
        }

        // 필터링 재설정
        if(thisParams.mode == 'dir') {
          this.filterHides = ['DEL'];
        } else {
          if (thisParams.mode == 'receive') {
            this.filterHides = ['TEMP', 'DEL'];
          } else if (thisParams.mode == 'send') {
            this.filterHides = ['TEMP', 'DEL'];
          } else if (thisParams.mode == 'temp') {
            this.filterHides = ['PROC', 'MYTURN', 'MYCOMPLETE', 'COMPLETE', 'RETURN', 'DEL'];
          } else if (thisParams.mode == 'trash') {
            this.filterHides = ['DEL'];
          }
        }

        if(reset) {
          this.$nextTick(() => {
            this.getList(true);
          });
        }
      });
    },
    async openFileList(item) {
      this.selEach = item;
      let envSeq = item.envSeq;
      if (item.envEachList && item.envEachList.length == 1) {
        envSeq = item.envEachList[0].envSeq;
      }

      let tempEnvFileList = (await this.$api('main/env/selectEnvFileList', { envNo: item.envNo, envSeq: envSeq })).list;
      this.envFileList = [...tempEnvFileList];
      this.$bvModal.show('modalEnvFileList');
    },
    async refreshEnvCancelTarget() {
      /** 반려 대상자 */
      this.envCancelTargetList = (await this.$api('main/env/selectEnvCancelTargetList', { envNo: this.env.envNo, envSeq: this.env.envSeq })).list;
    },
    async refreshEnvFile() {
      /** e-봉투 파일 */
      if(this.env) {
        let tempEnvFileList = (await this.$api('main/env/selectEnvFileList', { envNo: this.env.envNo, envSeq: this.env.envSeq })).list;
        this.envFileList = [...tempEnvFileList];
      }
    },
    async refreshEnvChat() {
      if(this.env) {
        /** 참여자 (중복 제거, 자기자신 제거) */
        this.envRecipientList = [];
        if(this.env.partiList && this.env.partiList.length) {
          for(let parti of this.env.partiList) {
            if(parti.ui > this.env.currUi) { // 다음 참여자에게만 메시지 전달 가능
              let partiNm = `${parti.partiNm || parti.grpNm}${parti.partiEmail ? ` (${parti.partiEmail})` : ''}`;
              this.envRecipientList.push({ key: parti.partiNo, email: parti.partiEmail, text: partiNm });
            }
          }
        }
        
        /** 채팅 */
        const { envNo, envSeq, myPartiNo } = this.env;
        const tempChatList = (await this.$api('main/env/selectEnvChatList', { envNo: envNo, envSeq: envSeq, partiNo: myPartiNo })).list || [];
        if(['VIEW_WRITE', 'VIEW'].includes(this.env.myMsgUseType)) {
          this.envChatList = [...tempChatList.filter(obj => obj.showChat)];
        }
        
        /** 경고창 표시 */
        if(tempChatList) {
          const tempAlertChatList = tempChatList.filter(obj => obj.showAlert);
          if(tempAlertChatList && tempAlertChatList.length) {
            for(const chat of tempAlertChatList) {
              if(chat.showAlert && !chat.confirm) {
                const body = `
                  <div class="rounded text-gray-900 fw-semibold mw-lg-400px text-start">
                    <div class="d-flex align-items-center mb-4">
                      <span v-if="chat.header" class="me-2 badge badge-sm badge-${chat.headerVariant}">${chat.header}</span>
                      <b class="fs-7">${chat.regUserNm}</b>
                      <span class="flex-grow-1 text-right fs-8 text-muted ms-2">${chat.regDt.f('datetime-local')}</span>
                    </div>
                    <div style="white-space: pre-line;">${chat.message}</div>
                  </div>
                `;

                if(await this.$alert(body, { size: 'w-350', confirm: true, okTitle: '다시보지않기', cancelTitle: this.$t('닫기') })) {
                  this.confirmEnvChat(chat);
                }
              }
            }
          }
        }
      }
    },
    async refreshEnvChatCnt() {
      if(this.env) {
        this.envChatCnt = this.envChatList.length;
        if(this.envChatList) {
          this.newEnvChatCnt = this.envChatList.filter(obj => !obj.confirm).length;
        }
      }
    },
    async refreshEnvFileCnt() {
      if(this.env) {
        this.envFileCnt = this.envFileList.length;
      }
    },
    async confirmEnvChat(chat) {
      const res = await this.$api('main/env/confirmEnvChat', { messageId: chat.messageId });      
      if(res.success) {
        for(let i = 0; i < this.envChatList.length; i++) {
          if(this.envChatList[i].messageId === res.data.messageId) {
            this.$set(this.envChatList, i, res.data);
          }
        }
      } else {
        this.$toast(res.msg, { variant: 'fail', toaster: 'b-toaster-bottom-right' });
      }
    },
    async insertEnvChat(chatData) {
      if(chatData.recipients.length == 0) {
        this.$toast(this.$t('대상자를 선택하세요.'), { variant: 'warning', toaster: 'b-toaster-bottom-right' });
      } else if(chatData.message == '') {
        this.$toast(this.$t('메시지를 입력하세요.'), { variant: 'warning', toaster: 'b-toaster-bottom-right' });
      } else {
        if (await this.$alert(this.$t(chatData.messageId ? '수정 하시겠습니까?' : '작성 하시겠습니까?'), { confirm: true })) {
          const formData = new FormData();
          formData.headers = { 'Content-Type': 'multipart/form-data' };
          formData.append('envNo', this.env.envNo);
          formData.append('envSeq', this.env.envSeq);
          formData.append('messageId', chatData.messageId);
          formData.append('message', chatData.message);
          formData.append('partiNos', chatData.recipients);
          for(const file of chatData.files) {
            formData.append('files', file);
          }
          formData.append('deleteFileIds', chatData.deleteFileIds);
          const res = await this.$api('main/env/insertEnvChat', formData);
          this.$toast(res.msg, { variant: res.success ? 'success' : 'danger', toaster: 'b-toaster-bottom-right' });
          if(res.success) {
            if(chatData.messageId) { // 수정
              this.$set(this.envChatList, this.envChatList.findIndex(item => item.messageId === chatData.messageId), res.data);
            } else { // 신규입력
              this.envChatList.push(res.data);
            }
            this.refreshEnvFile();
            this.refreshEnv([this.env.envNo]);
          }
        }
      }
    },
    async deleteEnvChat(chat) {
      if ((await this.$alert(this.$t('삭제하시겠습니까?'), { confirm: true }))) {
        const res = await this.$api('main/env/deleteEnvChat', { messageId: chat.messageId });
        this.$toast(res.msg, { variant: res.success ? 'success' : 'danger', toaster: 'b-toaster-bottom-right' });
        if(res.success) {
          this.envChatList.splice(this.envChatList.findIndex(item => item.messageId === chat.messageId), 1);
          this.refreshEnvFile();
          this.refreshEnv([this.env.envNo]);
        }
      }
    },
    async insertEnvFile(files) {
      const selEnv = this.env || this.selEach || this.sel;
      if(files.length == 0) {
        this.$toast('파일을 추가하세요.', { variant: 'warning', toaster: 'b-toaster-bottom-right' });
      } else {
        const formData = new FormData();
        formData.headers = { 'Content-Type': 'multipart/form-data' };
        formData.append('envNo', selEnv.envNo);
        formData.append('envSeq', selEnv.envSeq);
        formData.append('attachType', 'EXTERNAL');
        for(const file of files) {
          formData.append('files', file);
        }
        if (selEnv.myPartiNo != undefined) formData.append('partiNo', selEnv.myPartiNo);
        const res = await this.$api((this.linkKey ? 'nonauth/' : '') + 'main/env/insertEnvAttachFileList', formData);
        if(res.success) {
          for(const envFile of res.list) {
            this.envFileList.push(envFile);
          }
          this.$toast(res.msg, { variant: 'success', toaster: 'b-toaster-bottom-right' });
          this.refreshEnv([selEnv.envNo]);
        } else {
          this.$toast(res.msg, { variant: 'fail', toaster: 'b-toaster-bottom-right' });
        }
      }
    },
    async deleteEnvFile(file) {
      const selEnv = this.env || this.selEach || this.sel;
      let res;
      if ((await this.$alert(this.$t('삭제하시겠습니까?'), { confirm: true }))) {
        if(file.envAttachSeq) { // 첨부파일
          res = await this.$api('main/env/deleteEnvAttachFile', { fileId: file.fileId });
          this.$toast(res.msg, { variant: res.success ? 'success' : 'danger', toaster: 'b-toaster-bottom-right' });
          if(res.success) {
            this.envFileList.splice(this.envFileList.findIndex(item => item.fileId === file.fileId), 1);
          }
        } else { // 채팅파일
          res = await this.$api('main/env/deleteEnvChatFile', { messageId: file.messageId, seq: file.seq });
          this.$toast(res.msg, { variant: res.success ? 'success' : 'danger', toaster: 'b-toaster-bottom-right' });
          if(res.success) {
            this.envFileList.splice(this.envFileList.findIndex(item => item.fileId === file.fileId), 1);
          }
        }
      }

      if(res.success) {
        this.refreshEnvChat();
        this.refreshEnv([selEnv.envNo]);
      }
    },
    async downloadEnvFile(urls) {
      if(urls.length == 1) {
        window.location = this.$url(urls[0], true);
      } else if(urls.length > 1) {
        const filename = (this.env || this.sel).envNm;
        window.location = this.$downloadMulti(urls, filename);
      }
    },
    partiSelTreeActions(item) {
      return item.grpId ? `<span class="btn btn-xs btn-light-primary" action="grp_sel">${this.$t('선택')}</span>` : ``;
    },
    async choicePartiGrp({item, action} = {}) {
      if(action == 'grp_sel') {   
        this.assignPartiMember({item});
        return;
      } else {
        this.onTyping = false;
        this.partiParams.selType = item.type;
        this.partiParams.selKey = item.key;
        this.partiParams.searchKeyword = '';
        this.unmaskKey = '';
        this.selectPartiMemberList(item.type == 'cust' ? {selCustId: item.key} : {selGrpId: item.key});
      }
    },
    async searchPartiMemberList() {
      if(this.partiParams.searchKeyword) {
        this.onTyping = false;
        this.unmaskKey = '';
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword});
      }
    },
    async removeSearchPartiMember() {
      this.partiParams.searchKeyword = '';
      this.partiSearchMode = false;
      this.unmaskKey = '';
    },
    async reqUnmask() {
      const { success, msg, data } = await this.$api('cmm/unmask', { unmaskActCd: 'ENV_SRC_MEMBER' });
      if (!success) return this.$alert(msg);
      this.unmaskKey = data.unmaskKey;
      if(this.partiSearchMode) {
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword, unmaskKey: this.unmaskKey});
      } else {
        let params = this.partiParams.selType == 'cust' ? {selCustId: this.partiParams.selKey} : {selGrpId: this.partiParams.selKey};
        params.unmaskKey = this.unmaskKey;
        this.selectPartiMemberList(params);
      }
    },
    async selectPartiMemberList(params) {
      if(!this.onTyping) {
        if(this.partiParams.searchKeyword) { // 검색 모드
          this.allPartiMemberList = [];
          const resultList = (await this.$api('main/tmpl/selectPartiMemberList', params)).list;
          this.allPartiMemberList = [...resultList];
          this.partiSearchMode = true;
        } else {
          this.partiMemberList = [];
          const resultList = (await this.$api('main/tmpl/selectPartiMemberList', params)).list;
          this.partiMemberList = [...resultList];
          this.partiSearchMode = false;
        }
        this.onTyping = false;
      }
    },
    async assignPartiMember({item}) {
      const res = (await this.$api('main/env/validParti', {memberId: item.memberId || '', grpId: item.grpId || '', roleNm: this.role.roleNm || '', prodId: this.env.prodId || '', taskId: this.role.taskId || ''}));
      if(res.success) {
        let selParti;
        if(item.userId) { // 멤버 선택
          selParti = { partiNm: item.userNm, partiEmail: item.email, userId: item.userId, memberId: item.memberId, grpId: undefined, grpNm: undefined };
        } else { // 그룹 선택
          selParti = { partiNm: item.grpNm, partiEmail: undefined, userId: undefined, memberId: undefined, grpId: item.grpId };
        }
        Object.assign(this.role, selParti);
        this.$forceUpdate();
        this.$bvModal.hide('참여자추가');
      } else {
        return this.$alert(res.msg.replace('\n', '<br />'));
      }
    },
    async removeParti(roleSeq, item) {
      this.$set(this.env.envRoleList, roleSeq - 1, { ...item, partiNm: undefined, partiEmail: undefined, userId: undefined, memberId: undefined, grpId: undefined, grpNm: undefined });
      this.$forceUpdate();
    },
    async openPartiSelTree(roleSeq) {
      if (roleSeq) {
        this.role = this.env.envRoleList[roleSeq - 1];
      }
      else roleSeq = this.env.envRoleList.indexOf(this.role) + 1;
      
      // 매번 초기화
      let custItems = [];
      const custList = (await this.$api('main/env/selectPartiGrpList', {})).list;
      custList.forEach((cust) => {
        let custItem = Object.assign(cust, {icon: 'bi-building-fill', type: 'cust', key: cust.custId, label: cust.custName, children: []});
        custItems.push(custItem);
        for(const grp of cust.grpList) {
          let currItem = grp.pGrpId == 0 ? custItem : cust.grpList.find(d => d.grpId == grp.pGrpId)
          currItem.children.push(Object.assign(grp, {icon: 'bi-people-fill', type: 'grp', key: grp.grpId, label: grp.grpNm, children: []}));
        }
      });

      this.partiSelTree = [...custItems];
      this.partiParams = { selType: '', selKey: '', searchKeyword: '' };
      this.partiSearchMode = false;
      
      // 참여자 목록 초기화
      this.$nextTick(() => {
        this.partiMemberList = [];
        this.allPartiMemberList = [];
      });
      
      this.$bvModal.show('참여자추가');
    },
    showEnvMsg(title, content, variant) {
      this.$bvToast.hide();
      setTimeout(() => {
        this.$toast(content, { title: title, variant: `${variant || 'success'}`, toaster: 'b-toaster-bottom-right toast_env_msg', headerClass: '', autoHideDelay: 300000 });
      }, 1000);
    },
    async showEnv() {
      await this.$delay(100);
      this.$bvModal.show('SHOW_ENV');
    },
    async downloadEnv(url) {
      this.$download(this.$url(url));
    },
    async downloadEnvAudit() {
      const e = this.env, { envAuditList } = (await this.$api('main/env/selectEnvAudit', { envNo: this.env.envNo, envSeq: this.env.envSeq })).data;
      const nm = this.$t('감사추적인증서'), enm = this.$t('e봉투') + ' ';
      this.$download(this.$url((await this.$api('convertHtmltoPdf', this.$json2formdata(`${decodeURIComponent('%EF%BB%BF')}<html><head><style>table{font-family:'Malgun Gothic';border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}th[colspan]{border:none}</style></head><body><table>
        <tr><th colspan=3 style="font-size:120%;text-align:center;padding-bottom:20px">${nm}</tr>
        <tr><th colspan=3 align="left">${enm + this.$t('정보')}</th></tr>
        <tr><td style="background-color:#eee">${enm + this.$t('이름')}</td><td colspan=2>${e.envNm}</td></tr>						
        <tr><td style="background-color:#eee">${enm + this.$t('아이디')}</td><td colspan=2>${e.envId}</td></tr>						
        <tr><td style="background-color:#eee">${this.$t('원본검증 시간') + '(TSA)'}</td><td colspan=2>${(e.tsaDt || '').f('datetime-local')}</td></tr>						
        <tr><td style="background-color:#eee">${this.$t('회람상태')}</td><td colspan=2>${e.statusNm}</td></tr>						
        <tr><td style="background-color:#eee">${this.$t('회람완료 시간')}</td><td colspan=2>${e.statusDt.f('datetime-local')}</td></tr>						
        <tr><td style="background-color:#eee">${this.$t('문서페이지 수')}</td><td colspan=2>${this.signerScope.docs.map(d => d.pages.length).sum()}</td></tr>						
        <tr><th colspan=3></th></tr>
        <tr><th colspan=3 align="left">${this.$t('참여자')} ${this.$t('정보')}</th></tr>
        <tr><td style="background-color:#eee">${this.$t('참여자')}</td><td style="background-color:#eee">${this.$t('이름')}</td><td style="background-color:#eee">${this.$t('이메일')}</td></tr>
        <tr><td>${e.partiList.map(r => `${r.roleNm}</td><td>${r.partiNm}</td><td>${r.partiEmail || ''}`).join('</td></tr><tr><td>')}</td></tr>                  
        <tr><th colspan=3></th></tr>
        <tr><th colspan=3 align="left">${this.$t('회람이력')}</th></tr>
        <tr><td style="background-color:#eee">${this.$t('시간')}</td><td style="background-color:#eee">${this.$t('IP address')}</td><td style="background-color:#eee">${this.$t('수행내역')}</td></tr>
        <tr><td>${envAuditList.map(a => `${a.actDt.f('datetime-local')}</td><td>${a.accessIp}</td><td>${a.actCont}`).join('</td></tr><tr><td>')}</td></tr>                  
      </table></body></html>`, 'file', `${nm}_${this.env.envNm}.html`, 'text/html;charset=utf-8'))).data.url), `${nm}_${this.env.envNm}.pdf`);
    },
    async getList(reset) {
      if (this.linkKey) return;
      if (reset === true) { this.list = []; }
      const { list, parameter: { total } } = await this.$api('main/env/selectEnvList', { ...this.listParams, firstIndex: this.list.length + 1 });
      this.serverTotal = total;
      if (reset === true) {
        this.list = [...list];
      } else {
        this.list.push(...list);
      }

      if(this.listParams.dirId) {
        const dirItem = this.envDirList.find(dir => dir.dirId === this.listParams.dirId);
        this.subTitle = dirItem ? dirItem.dirNm : '';
      } else {
        const menuItem = this.envMenus.find(menu => menu.key === this.listParams.mode);
        this.subTitle = menuItem ? menuItem.label : '';
      }
    },
    async refreshEnv(envNos) {
      this.keepPage = true;
      for(let envNo of envNos) {
        const selEnv = (await this.$api('main/env/selectEnvOne', { envNo: envNo })).data;
        this.$set(this.list, this.list.findIndex(item => item.envNo === envNo), selEnv);
        if(this.sel && this.sel.envNo == envNo) {
          this.sel = selEnv;
        }
      }
      this.$nextTick(()=> { this.keepPage = false; });
    },
    beforeDestroy() {
      const iframe = this.$el.querySelector('iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.removeEventListener('click', this.clickSigner);
        window.removeEventListener('message', this.handleSigner);
      }
    },
    bindSignerEvents() {
      const iframe = this.$el.querySelector('iframe');
      if(iframe && iframe.contentWindow) {
        iframe.contentWindow.addEventListener('click', this.clickSigner);
        window.addEventListener('message', this.handleSigner);
      }
    },
    clickSigner() {
      this.toggleEnvAlerts(false);
    },
    handleSigner(event) {
      // 유효성 검사가 한번 수행된 이후, 항목 변경시 마다 해당 항목 유효성 검사
      if(this.editorValidResults.length > 0 && event.data.type == 'setCurrents') {
        const ctrl = event.data.parameters.ctrl;
        this.genEditorValidResult(ctrl);
      }
    }
  },
}
</script>

<style>
.toast_env_msg { bottom: 100px !important; }
.env_sidebar_tab .nav-tabs .nav-link:not(.active) { background-color: rgba(var(--kt-warning-rgb), 0.6); }
</style>